/**
 * Pages module.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 01/09/2018
 */
(function () {
  'use strict';

  var app = angular.module('BlurAdmin.pages', [
    'ui.router',
    'BlurAdmin.pages.dashboard',
    'BlurAdmin.pages.profile',
    'BlurAdmin.pages.cms',
    // 'BlurAdmin.pages.rolePermission',
    'BlurAdmin.pages.login',
    // 'BlurAdmin.pages.faq',
    'BlurAdmin.pages.emailTemplate',
    'BlurAdmin.pages.resetPassword',
    // 'BlurAdmin.pages.subAdmin',
    'BlurAdmin.pages.error403',
    // 'BlurAdmin.pages.settings',
    'BlurAdmin.pages.user',
    'BlurAdmin.pages.terms',
    'BlurAdmin.pages.privacy',
    // 'BlurAdmin.pages.clinic',
    'BlurAdmin.pages.hearing',
    'BlurAdmin.pages.contactClinic',
  ])
          .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/login');
  }

  app.controller('mainController', fnMainController);
  function fnMainController($scope, $state, $rootScope, $http, $cookies, $window, toastr) {

      /**
       * LogOut method is use for logout user.
       * created on 01/10/2018
       */
      $scope.logOut = function () {
          $rootScope.globals = {};
          $rootScope.permissionArr = [];
          $window.localStorage.removeItem('globals');
          $state.go('login');
      };
      /**
      * UCCap For First Caracter Capital Of String.
      * Created on 01/10/2018
      */
      $scope.UcCap =  function (string){
          return string.charAt(0).toUpperCase() + string.slice(1);
      };
      /**
      * Get Date Formate Global.
      * created on 01/10/2018
      */
      $scope.getGlobalDateFormat = function (data){
          var getDate=Date.parse(data);
          return moment(getDate).format('MM/DD/YYYY');
      }
      $scope.saveDateFormatInDB = function (data){
          var saveDate=Date.parse(data);
          return moment(saveDate).format('YYYY-MM-DD');
      }
      $scope.getGlobalDateTimeFormat = function (data){
          if(data!='' && data!=null) {
            var getDate=Date.parse(data);
            return moment(getDate).format('MM/DD/YYYY HH:mm');
          }else{
              return 'N/A';
          }
      }

      /**
       * Data url encode method is use encode request data.
       * created on 01/10/2018
       */
      $scope.dataUrlEncode = function (obj) {
          var str = "";
          for (var key in obj) {
              if (str != "") {
                  str += "&";
              }
              str += key + "=" + encodeURIComponent(obj[key]);
          }
          return str;
      };
      $rootScope.sessionExpired = function() {
        $rootScope.globals = {};
        $window.localStorage.removeItem('globals');
        $state.go('login');
        toastr.error("Your session has been expired.");
      };

      /**
       * get status class from status
       * @param {type} status
       * @returns {pages.module_L6.fnMainController.$rootScope.getStatusClass.stClass|stClass}
       */
      $rootScope.getStatusClass = function(status) {
          var stClass = {
              "Active" : "label label-success",
              "Inactive" : "label label-danger",
              "Pending" : "label label-default"
          }
          return stClass[status];
      }
      /**
       * check Permission method is use check permission for actions.
       * created on 01/24/2018
       */
      $scope.checkPermission = function (slug) {
          if($rootScope.userRole && $rootScope.userRole!='SUPER_ADMIN' && $rootScope.permissionArr && $rootScope.permissionArr.indexOf(slug) === -1){
            return false;
          }else{
            return true;
          }
      };
  }
  /**
  * Error Interceptor factory is use logout user after unauthorised.
  * created on 01/10/2018
  */
  app.factory('errorInterceptor', function($q, $rootScope, $cookieStore, $timeout) {
    return {
      request: function(config) {
        return config || $q.when(config);
      },
      requestError: function(request) {
        return $q.reject(request);
      },
      response: function(response) {
        return response || $q.when(response);
      },
      responseError: function(response) {
        var responseData=response.data;
        if (responseData.meta && responseData.meta.status_code === 401) {
          $rootScope.sessionExpired();
        }
        if (responseData.meta && responseData.meta.status_code === 404) {

        }
        if (responseData.meta && responseData.meta.status_code >= 500) {}
        return $q.reject(response);
      }
    };
  });

  app.config(function($httpProvider) {
    $httpProvider.interceptors.push('errorInterceptor');
  });

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.clinic', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('clinic', {
        url: '/clinic',
        templateUrl: 'app/pages/common/clinic/clinic.html',
        controller: 'clinicCtrl as vm',
        title: 'Manage Clinic',
        permissionKey:'CLINIC_LIST',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-ambulance',
          menuName: 'Manage Clinic'
        },
      }).state('add-clinic', {
        url: '/add-clinic',
        templateUrl: 'app/pages/common/clinic/addClinic.html',
        controller: 'clinicCtrl as clinic',
        title: 'Add Clinic',
      }).state('edit-clinic', {
        url: '/edit-clinic',
        templateUrl: 'app/pages/common/clinic/addClinic.html',
        controller: 'clinicCtrl as clinic',
        title: 'Edit Clinic',
      });
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.cms', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('cms-management', {
        url: '/cms-management',
        templateUrl: 'app/pages/common/cms/cms.html',
        controller: 'cmsCtrl',
        title: 'CMS Management',
        permissionKey:'CMS_LIST',
        sidebarMeta: {
          order: 1,
          icon: 'fa fa-cog',
          menuName: 'CMS Management'
        },
      }).state('add-cms', {
        url: '/add-cms',
        templateUrl: 'app/pages/common/cms/addCMS.html',
        controller: 'cmsCtrl',
        title: 'Add CMS',
      }).state('edit-cms', {
        url: '/edit-cms',
        templateUrl: 'app/pages/common/cms/addCMS.html',
        controller: 'cmsCtrl',
        title: 'Edit CMS',
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.contactClinic', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('contactClinic', {
        url: '/contact-clinic',
        templateUrl: 'app/pages/common/contactClinic/contactClinic.html',
        controller: 'contactClinicCtrl as vm',
        title: 'Contact Clinic',
        permissionKey:'CONTACT_CLINIC_LIST',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-ambulance',
          menuName: 'Contact Clinic'
        },
      });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/common/dashboard/dashboard.html',
          title: 'Dashboard',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
            menuName: 'Dashboard'
          },
        });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.emailTemplate', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('email-template', {
        url: '/email-template',
        templateUrl: 'app/pages/common/emailTemplate/emailTemplate.html',
        controller: 'emailTemplateCtrl',
        title: 'Email Template',
        permissionKey:'EMAIL_TEMP_LIST',
        sidebarMeta: {
          order: 3,
          icon: 'fa fa-envelope-o',
          menuName: 'Email Template'
        },
      }).state('add-email-template', {
        url: '/add-email-template',
        templateUrl: 'app/pages/common/emailTemplate/addEmailTemplate.html',
        controller: 'emailTemplateCtrl',
        title: 'Add Email Template',
      }).state('edit-email-template', {
        url: '/edit-email-template',
        templateUrl: 'app/pages/common/emailTemplate/addEmailTemplate.html',
        controller: 'emailTemplateCtrl',
        title: 'Edit Email Template',
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.error403', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('error-403', {
        url: '/error-403',
        title: 'Error 403',
        templateUrl: 'app/pages/common/error403/error403.html',
        controller: 'error403Ctrl'
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.faq', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('faq-management', {
        url: '/faq-management',
        templateUrl: 'app/pages/common/faq/faq.html',
        controller: 'faqCtrl',
        title: 'FAQ Management',
        permissionKey:'FAQ_LIST',
        sidebarMeta: {
          order: 2,
          icon: 'fa fa-question-circle',
          menuName: 'FAQ Management'
        },
      }).state('add-faq', {
        url: '/add-faq',
        templateUrl: 'app/pages/common/faq/addFAQ.html',
        controller: 'faqCtrl',
        title: 'Add FAQ',
      }).state('edit-faq', {
        url: '/edit-faq',
        templateUrl: 'app/pages/common/faq/addFAQ.html',
        controller: 'faqCtrl',
        title: 'Edit FAQ',
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.hearing', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('hearing', {
        url: '/hearing',
        templateUrl: 'app/pages/common/hearingTest/hearing.html',
        controller: 'hearingCtrl as vm',
        title: 'Manage Hearing Test',
        permissionKey:'HEARING_LIST',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-users',
          menuName: 'Manage Hearing Test'
        },
      }).state('show-hearing', {
        url: '/show-hearing',
        templateUrl: 'app/pages/common/hearingTest/viewHearing.html',
        controller: 'hearingCtrl as hearing',
        title: 'Show Hearing Test',
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.login', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        title: 'Login',
        templateUrl: 'app/pages/common/login/login.html',
        controller: 'loginCtrl',
        blank: true
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.privacy', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('privacy-policy', {
        url: '/privacy-policy',
        title: 'Privacy Policy',
        templateUrl: 'app/pages/common/privacyPolicy/privacy-policy.html',
        controller: 'privacyCtrl'
      });
  }

})();

/**
 * @author Harsha Prajapati<harsha.prajapati@brainvire.com>
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('profile', {
          url: '/profile',
          title: 'Profile',
          templateUrl: 'app/pages/common/profile/profile.html',
          controller: 'profileCtrl',
        });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.resetPassword', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('reset-password', {
        url: '/password/reset',
        title: 'Reset Password',
        templateUrl: 'app/pages/common/resetPassword/resetPassword.html',
        controller: 'resetPasswordCtrl',
        blank: true
      });
  }

})();

/**
 * @author Rahul
 * @Purpose show and assign permissions
 * created on 10.01.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.rolePermission', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /**
   * @ngInject
   * @param {type} $stateProvider
   * @returns {undefined}
   */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('admin-permissions', {
          url: '/role-permissions',
          templateUrl: 'app/pages/common/rolePermission/rolePermission.html',
          controller:'rolePermissionCtrl',
          title: 'System Permissions',
          permissionKey:'ROLE_PERMISSION_LIST',
          sidebarMeta: {
            order: 3,
            icon: 'fa fa-users',
            menuName: 'System Permissions'
          }
        });
  }

})();

/**
 * @author Harsha Prajapati<harsha.prajapati@brainvire.com>
 * created on 01/29/2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('settings', {
          url: '/settings',
          title: 'Settings',
          templateUrl: 'app/pages/common/settings/settings.html',
          controller: 'settingsCtrl',
          permissionKey:'CONFIG_LIST',
          sidebarMeta: {
            order: 6,
            icon: 'fa fa-cogs',
          }
        });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.terms', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('terms', {
        url: '/terms',
        title: 'Terms & Conditions',
        templateUrl: 'app/pages/common/staticPages/terms.html',
        controller: 'termsCtrl'
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.subAdmin', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('sub-admin', {
        url: '/sub-admin',
        templateUrl: 'app/pages/common/subAdmin/subAdmin.html',
        controller: 'subAdminCtrl as vm',
        title: 'Manage Sub Admin',
        permissionKey:'SUB_ADMIN_LIST',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-user',
          menuName: 'Manage Sub Admin'
        },
      }).state('add-sub-admin', {
        url: '/add-sub-admin',
        templateUrl: 'app/pages/common/subAdmin/addSubAdmin.html',
        controller: 'subAdminCtrl as subAdmin',
        title: 'Add Sub Admin',
      }).state('edit-sub-admin', {
        url: '/edit-sub-admin',
        templateUrl: 'app/pages/common/subAdmin/addSubAdmin.html',
        controller: 'subAdminCtrl as subAdmin',
        title: 'Edit Sub Admin',
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.user', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('user', {
        url: '/user',
        templateUrl: 'app/pages/common/user/user.html',
        controller: 'userCtrl as vm',
        title: 'Manage Users',
        permissionKey:'USER_LIST',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-users',
          menuName: 'Manage Users'
        },
      }).state('add-user', {
        url: '/add-user',
        templateUrl: 'app/pages/common/user/addUser.html',
        controller: 'userCtrl as user',
        title: 'Add User',
      }).state('edit-user', {
        url: '/edit-user',
        templateUrl: 'app/pages/common/user/addUser.html',
        controller: 'userCtrl as user',
        title: 'Edit User',
      }).state('verification', {
        url: '/verification/{token}',
        templateUrl: 'app/pages/common/user/verification.html',
        controller: 'userCtrl as user',
        title: 'Verification',
      });
  }

})();

'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'BlurAdmin.theme',
  'BlurAdmin.pages',
  'datatables',
  'datatables.buttons',
  'ngCookies',
  'summernote',
  '720kb.datepicker'
]).run(function ($rootScope,$state, $http, toastrConfig,toastr, DTDefaultOptions, $window, apiService,$timeout) {
  /**
   * Set toastr configuration
   **/
  $rootScope.currentYear = moment().format('YYYY');
  $rootScope.projectName = 'Hearing Tool';
  toastrConfig.preventOpenDuplicates = true;
  toastrConfig.closeButton = true;

  $rootScope.currentState = 'dashboard';
  /**
   * Set Datatable loading image
   **/
  DTDefaultOptions.setLoadingTemplate('<div class="row"><div class="col-md-12"><img class="center-block" width="70" height="70" ng-src="{{::( \''+'loader_big.gif'+'\' | appImage )}}"><br><p class="text-center">Loading</p></div></div>');

  /**
   * Set API URL
   **/
  $rootScope.host = "https://api.intermountainhearingcenters.com";
  // $rootScope.host = "http://192.168.11.56/hearingtool/public/";
  $rootScope.numberOfRecord = 11;
  /**
   * Store Logged in User Data
   **/
  $rootScope.globals = {};
  var cookieGlobal = $window.localStorage.getItem('globals');
  if (cookieGlobal) {
    $rootScope.globals = apiService.decriptData(cookieGlobal);
  }
  $rootScope.$on('$stateChangeStart', function (evt, to, params,from) {
    /**
     * If state is login and reset-password then append /v1 in baseUrl else not
     **/
    var stateArray=["login","reset-password","profile"];
    if (stateArray.indexOf(to.name) === -1) {
      $rootScope.baseUrl = $rootScope.host+'/api';
    }else{
      $rootScope.baseUrl = $rootScope.host+'/api/v1';
    }
    $rootScope.subTitle=to.title;
    $rootScope.showNavigation=false;
    $rootScope.title=$rootScope.projectName+' | '+$rootScope.subTitle
    if ($rootScope.globals.currentUser) {
        $http.defaults.headers.common['Authorization'] = $rootScope.globals.currentUser.token_type+' ' + $rootScope.globals.currentUser.access_token;
        $rootScope.permissionArr = $rootScope.globals.currentUser.permission;
        $rootScope.userRole=$rootScope.globals.currentUser.userRole;
    }else{
        $rootScope.permissionArr = [];
        $window.localStorage.removeItem('globals');
    }

    if(to.name == 'login' || to.name == 'reset-password' || to.name == 'terms' || to.name == 'verification' || to.name == 'privacy-policy'){
      $rootScope.showNavigation=true;
    }

    if (to.name !== 'login' && !$rootScope.globals.currentUser && to.name !== 'reset-password' && to.name !== 'terms' && to.name !== 'verification' && to.name !== 'privacy-policy') {
            evt.preventDefault();
            $rootScope.showNavigation=true;
            $state.go('login');
            toastr.error("Login is required");
    }
    if (to.name == 'login' && $rootScope.globals.currentUser) {
        $timeout(function () {
            $state.go('dashboard');
        }, 60);
    }
  })
});

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();

(function () {
  'use strict';

  var appTheme = angular.module('BlurAdmin.theme');

  /**
    * Limit To Directive for restrict to user for caracter.
    * created on 01/16/2018
    */
    appTheme.directive("limitTo", [function() {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                var limit = parseInt(attrs.limitTo);
                var allowedKeys = [8, 38, 40, 46];
                angular.element(elem).on("keypress", function(event) {
                    var key = event.which || event.keyCode;
                    if (this.value.length === limit && allowedKeys.indexOf(key) < 0 ){
                        event.preventDefault();
                    }
                });
            }
        };
    }]);
    appTheme.directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('apiService', apiService);

function apiService($q, $http,$rootScope,toastr) { // inject services and/or providers here

  return {
    loaderShow:function() {
       angular.element('.ajaxLoader').show();
    },
    loaderHide:function() {
       angular.element('.ajaxLoader').hide();
    },
    authLoaderShow:function() {
       angular.element('.authLoader').show();
    },
    authLoaderHide:function() {
       angular.element('.authLoader').hide();
    },
    encriptData:function(data){
      return CryptoJS.AES.encrypt(JSON.stringify(data), "images75long9tinsel");
    },
    decriptData:function(data){
      var decrypted =  CryptoJS.AES.decrypt(data, "images75long9tinsel");
      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    },
    ellipsisString:function(data, type, full, meta) {
        if (typeof data == 'string') {
            var stringVal = data.toString();
            if(stringVal.length  > 60){
                stringVal = stringVal.substring(0,60)+'...'
            }
            return '<span title="' + data + '">' + stringVal  + '</span>';
        }
    }
  }
}
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();

/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * clinic controller handle all action related clinic.
 * @author Riya Mansuri <riya.mansuri@brainvire.com>
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.clinic')
            .controller('clinicCtrl', clinicCtrl);
    /** @ngInject */
    function clinicCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $q, $filter, $window) {

        /**
         * check permission to display list
         * created on 01/24/2018
         */
        // if (!$scope.checkPermission('CLINIC_LIST')) {
        //     $state.go('error-403');
        // }

        $rootScope.currentState = 'clinic';
        $scope.minDate = new Date().toDateString();
        var vm = this;
        $scope.vmAdded = this;

        /**
         * Search apply is use to apply filters
         * created on 01/25/2018
         */
        $scope.searchApply = function () {

            $scope.vmAdded.dtInstance.DataTable.draw();
        }
        $scope.resetSearch = function () {
            vm.clinic_name = '';
            vm.status = '';
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
         * Server data method is use for load data from API.
         */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/clinic/list',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    clinic_name: vm.clinic_name ? vm.clinic_name : '',
                    status: vm.status ? vm.status : '',
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function (result) {
                apiService.loaderHide();
                var result = result.data.data.original;
                if (result) {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                } else {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                apiService.loaderHide();
                fnCallback(records);
            }, function errorCallback(response) {
                apiService.loaderHide();
            })
        }
        ;
        /**
         * Get data table method is use get list of clinic.
         * created on 01/24/2018
         */
        $scope.getDataTable = function () {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('srNum').withTitle('Sr.No'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('id').notVisible());
            vm.dtColumns.push(DTColumnBuilder.newColumn('clinic_name').withTitle('Clinic Name'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').renderWith(statusHtml).withOption('className', 'tableStatus'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Registration at').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('updated_at').withTitle('Last updated at').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            // if($scope.checkPermission('USER_UPDATE') || $scope.checkPermission('USER_STATUS') || $scope.checkPermission('USER_CHANGE_PASSWORD') || $scope.checkPermission('USER_DELETE')){
            vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('Action').renderWith(actionHtml).withOption('className', 'tableActions').withOption('orderable', false));
            // }
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withFnServerData(serverData)
                    .withOption('serverSide', true)
                    .withPaginationType('simple_numbers')
                    .withOption('deferRender', true)
                    .withOption('searching', true)
                    .withOption('autoWidth', false)
                    .withOption('sDom', 'ZlB< "row" >rtip')
                    .withOption('bLengthChange', true)
                    .withOption('iDisplayLength', ($rootScope.numberOfRecord - 1))
                    .withOption('bInfo', true)
                    .withOption('oLanguage', {
                        "sSearch": ""
                    })
                    .withOption('pageLength', 10)
                    .withOption('createdRow', compileRow)
                    .withOption('order', [1, 'desc'])
                    .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
        /**
         * add clinic method is used for go to add clinic page.
         * created on 01/24/2018
         */
        $scope.addClinic = function () {
            $cookies.put('clinic-id', undefined);
            $state.go('add-clinic');
        }
        /**
         * edit clinic method is used for go to edit clinic page.
         * created on 01/24/2018
         */
        $scope.editClinic = function (id) {
            $cookies.put('clinic-id', id);
            $state.go('edit-clinic');
        }
        /**
         * Init complete method is use for add class on DOM of datatable.
         */
        function initComplete(row, data) {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
        }
        /**
         * Compile row method is use for compile row in angular.
         */
        function compileRow(row, data) {
            $compile(angular.element(row).contents())($scope);
        }
        /**
         * Open modal popup
         */
        $scope.open = function (page, id, status) {
            if (status == 1) {
                $rootScope.status = 'Active';
            } else {
                $rootScope.status = 'Inactive';
            }
            $rootScope.statusId = id;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };
        $scope.closeModal = function () {
            angular.element('.modal').slideUp("fast");
            angular.element('.modal-backdrop').remove();
            angular.element('body').removeClass('modal-open');
        };
        
        
        /**
         * Get edited clinic method is use for get edited clinic data.
         * created on 01/17/2018
         */
        $scope.getEditedClinic = function () {
            // if (!$scope.checkPermission('USER_CREATE') && $state.current.name == "add-user") {
            //     $state.go('error-403');
            // }
            // else if(!$scope.checkPermission('USER_UPDATE') && $state.current.name == "edit-user") {
            //     $state.go('error-403');
            // }
            if (!$state.current.name == "add-clinic") {
                $state.go('error-403');
            }
            else if(!$state.current.name == "edit-clinic") {
                $state.go('error-403');
            }
            else {
            if ($cookies.get('clinic-id') && $cookies.get('clinic-id') != undefined) {
                apiService.loaderShow();
                var vm = this;
                $http.get($rootScope.baseUrl + '/clinic/show/' + $cookies.get('clinic-id'))
                        .success(function (response) {
                            var getResponse = response.data;
                            vm.clinicId = getResponse.id;
                            vm.clinic_name = getResponse.clinic_name;
                            apiService.loaderHide();
                        }).error(function (error) {
                    var getError = error.data;
                    apiService.loaderHide();
                    if (getError && getError.meta) {
                        toastr.error(getError.meta.message);
                    } else {
                        $state.go('edit-clinic');
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                $state.go('add-clinic');
            }
        }
        };
        /**
         * Change status method is use for change status of clinic.
         * created on 01/12/2018
         */
        $scope.changeStatus = function () {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.statusId,
                    status: $rootScope.status
                };
                $http.put($rootScope.baseUrl + '/clinic/change_status', bodyData)
                        .success(function (result) {
                            if (result.meta.status == true) {
                                toastr.success(result.meta.message);
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.meta.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var statusError = error.data;
                    if (statusError && statusError.meta) {
                        toastr.error(statusError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };
        /**
         * Delete clinic method is use for delete clinic.
         * created on 01/17/2018
         */
        $scope.deleteClinic = function () {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                $http.delete($rootScope.baseUrl + '/clinic/delete/' + $rootScope.statusId)
                        .success(function (result) {
                            if (result.meta.status == true) {
                                toastr.success(result.meta.message);
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.meta.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var deleteError = error.data;
                    if (deleteError && deleteError.meta) {
                        toastr.error(deleteError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            $scope.popupShow.close();
        };

        
        /**
         * Save clinic data method is used for update clinic data.
         */

        $scope.saveClinicData = function () {
            if (!this.clinicFrm.clinic_name.$valid) {
                toastr.error("Please enter first name");
                angular.element('#clinic_name').focus();
                return;
            } 

            var bodyData = {
                clinic_name: this.clinic_name,
            };
            apiService.loaderShow();
            $scope.editedId = this.clinicId;
            if (this.clinicId) {
                $scope.saveUrl = $rootScope.baseUrl + '/clinic/update/' + this.clinicId;
                $scope.httpMethod = 'PUT';
            } else
            {
                $scope.saveUrl = $rootScope.baseUrl + '/clinic/create';
                $scope.httpMethod = 'POST';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                apiService.loaderHide();
                var responseData = response.data;
                if (responseData.meta.status == true) {
                    toastr.success(responseData.meta.message);
                    $state.go('clinic');
                } else {
                    $state.go('clinic');
                    toastr.error(responseData.meta.message);
                }
            }, function (error) {
                var errorData = error.data;
                apiService.loaderHide();
                if (errorData && errorData.meta) {
                    if (errorData.meta.message_code == 'VALIDATION_ERROR') {
                        if (errorData.errors.email) {
                            toastr.error(errorData.errors.email[0]);
                        }
                    } else {
                        toastr.error(errorData.meta.message);
                    }
                } else {
                    $state.go('clinic');
                    toastr.error("Something went wrong please try again.");
                }
            });
        };

        /**
         * Status Html method is use for prepare status badge.
         */
        function statusHtml(data) {
            var statusClass = $rootScope.getStatusClass(data);
            var statusBadge = '<span class="' + statusClass + ' font-size-14 margin-inline">' + data + '</span>';
            return statusBadge;
        }
        /**
         * Action Html method is use for prepare action html part.
         */
        function actionHtml(data, type, full) {
            var changeStatusValTo = 0;
            var editLinks = ' <a  href="javascript:void(0);" ng-click="editClinic(\'' + data + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a href="javascript:void(0);" ng-click="open(\'' + 'app/pages/common/clinic/deleteModal.html' + '\',' + data + ',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg"></i> </a>';
            var statusLinks = ' <a ng-click="open(\'' + 'app/pages/common/clinic/statusModal.html' + '\',' + data + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img class="mt-2px" src="assets/img/switch-on.png" width="24"/></a>';
            var statusClass = $rootScope.getStatusClass(full.status);
            var statusBadge = '<span class="' + statusClass + ' font-size-14 margin-inline">' + full.status + '</span>';
            if (full.status == 'Inactive') {
                changeStatusValTo = 1;
                statusLinks = ' <a ng-click="open(\'' + 'app/pages/common/clinic/statusModal.html' + '\',' + data + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img class="mt-2px" src="assets/img/switch-off.png" width="24"/></a>';
            }
            return editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
        }
    }
})();
/**
 * Cms controller handle all action related CMS pages.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.cms')
    .controller('cmsCtrl', cmsCtrl);

  /** @ngInject */
  function cmsCtrl($scope, $state, $cookies, $http, apiService, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, $q, $uibModal) {

    /**
    * check permission to display list
    * created on 01/24/2018
    */
    if(!$scope.checkPermission('CMS_LIST')){
      $state.go('error-403');
    }
    $rootScope.currentState = 'cms-management';

    /**
     * Get data table method is use get list of CMS Pages.
     * created on 01/09/2018
     */
    $scope.getDataTable = function() {
      var vm = this;
      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/content_page/list')
          .success(function(result) {
            vm.cms = [];
            var index = 1;
            var resultData=result.data;
            angular.forEach(resultData, function(value, key) {
              var changeStatusValTo = 0;
              var editLinks = ' <a ng-if="checkPermission(\''+'CMS_UPDATE'+'\')" href="javascript:void(0);" ng-click="editCMS(\'' + value.id + '\')"  title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
              var statusLinks = ' <a ng-if="checkPermission(\''+'CMS_STATUS'+'\')" ng-click="open(\'' + 'app/pages/common/cms/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img class="mt-2px" src="assets/img/switch-on.png" width="24"/></a>';
              var statusClass = $rootScope.getStatusClass(value.status);
              var statusBadge = '<span class="'+statusClass+' font-size-14 margin-inline">'+value.status+'</span>';

              if (value.status == 'Inactive') {
                  changeStatusValTo = 1;
                  statusLinks = ' <a ng-if="checkPermission(\''+'CMS_STATUS'+'\')" ng-click="open(\'' + 'app/pages/common/cms/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img class="mt-2px" src="assets/img/switch-off.png" width="24"/></a>';
              }
              var data = {
                index: index,
                id: value.id,
                cms_title: value.page_title,
                cms_status:statusBadge,
                operations: editLinks+ '&nbsp;' + statusLinks
              };
              vm.cms.push(data);
              index++;
            }, vm.cms);
            defer.resolve(vm.cms);
          }).error(function(error) {
            var errorData=error.data;
            if (errorData && errorData.meta) {
              toastr.error(errorData.meta.message);
            }
          });
        return defer.promise;
      }).withPaginationType('simple_numbers');
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('oLanguage', {"sSearch": ""});
      vm.dtOptions.withOption('pageLength', 10);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
      });

      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
        DTColumnBuilder.newColumn('cms_title').withTitle('Page Title'),
        DTColumnBuilder.newColumn('cms_status').withTitle('Status').withOption('className', 'tableStatus')
      ];
      if($scope.checkPermission('CMS_UPDATE') || $scope.checkPermission('CMS_STATUS')){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }
    }

    /**
     * addCMS method is use for go to add cms state .
     * created on 01/09/2018
     */
    $scope.addCMS = function() {
      $cookies.put('cms-id', undefined);
      $state.go('add-cms');
    }
    /**
     * editCMS method is use for go to edit cms state .
     * created on 01/09/2018
     */
    $scope.editCMS = function(id) {
      $cookies.put('cms-id', id);
      $state.go('edit-cms');
    }

    /**
     * Get edited cms method is use for get  cms data.
     * created on 01/09/2018
     */
    $scope.getEditedCms = function() {
      if(!$scope.checkPermission('CMS_CREATE') && $state.current.name == "add-cms"){
        $state.go('error-403');
      }
      else if(!$scope.checkPermission('CMS_UPDATE') && $state.current.name == "edit-cms") {
        $state.go('error-403');  
      }
      else {
      if ($cookies.get('cms-id') && $cookies.get('cms-id') != undefined) {
        apiService.loaderShow();
        var vm = this;
        $http.get($rootScope.baseUrl + '/content_page/show/' + $cookies.get('cms-id'))
          .success(function(response) {
            var getResponse=response.data;
            vm.cmsId = getResponse.id;
            vm.cmsTitle = getResponse.page_title;
            vm.cmsDescription = getResponse.description;
            vm.metaTitle = getResponse.meta_keywords;
            vm.metaDescription = getResponse.meta_description;
            vm.cmsStatus = getResponse.status;
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            var getError=error.data;
            if (getError && getError.meta) {
                toastr.error(getError.meta.message);
            }else {
              $state.go('edit-cms');
              toastr.error("Something went wrong please try again.");
            }
          });
      } else {
        $state.go('add-cms');
      }
  }
    };

    /**
     * Save CMs  method is use for save the cms data.
     * created on 01/12/2018
     */
    $scope.saveCMS = function() {
      if (!this.cmsFrm.inputCMSTitle.$valid) {
        angular.element('#inputCMSTitle').focus();
        toastr.error("Please enter cms title");
        return;
      } else if (!this.cmsDescription) {
        toastr.error("Please enter description");
        return;
      }else if (!this.cmsFrm.metaTitle.$valid) {
        angular.element('#metaTitle').focus();
        toastr.error("Please enter cms meta title");
        return;
      }else if (!this.cmsFrm.metaDescription.$valid) {
        angular.element('#metaDescription').focus();
        toastr.error("Please enter cms meta description");
        return;
      }else if (!this.cmsFrm.cmsStatus.$valid) {
        angular.element('#status').focus();
        toastr.error("Please select cms status");
        return;
      }
      var bodyData = {
        page_title: this.cmsTitle,
        description: this.cmsDescription,
        meta_keywords:this.metaTitle,
        meta_description:this.metaDescription,
        status:this.cmsStatus
      };
      apiService.loaderShow();
        $scope.saveUrl = $rootScope.baseUrl + '/content_page/create';
        $scope.httpMethod = 'POST';
        $scope.editedId = this.cmsId;
        if (this.cmsId) {
          $scope.saveUrl = $rootScope.baseUrl + '/content_page/update/' + this.cmsId;
          $scope.httpMethod = 'PUT';
        }
        $http({
          url: $scope.saveUrl,
          method: $scope.httpMethod,
          data: $scope.dataUrlEncode(bodyData),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(response) {
          apiService.loaderHide();
          var responseData = response.data;
          if (responseData.meta.status == true) {
            toastr.success(responseData.meta.message);
            $state.go('cms-management');
          } else {
            $state.go('cms-management');
            toastr.success(responseData.meta.message);
          }
        }, function(error) {
          apiService.loaderHide();
          var errorData=error.data;
          if (errorData && errorData.meta) {
            if (errorData.meta.message_code == 'VALIDATION_ERROR') {
              if(errorData.errors.page_title){
                toastr.error(errorData.errors.page_title[0]);
              }
            }else{
                toastr.error(errorData.meta.message);
            }
          }else {
            $state.go('cms-management');
            toastr.error("Something went wrong please try again.");
          }
        });
    };
    /**
     * Open model.
     * created on 01/12/2018
     */
    $scope.open = function (page,id,status) {
        $rootScope.statusId = id;
        if(status==1){
          $rootScope.status = 'Active';
        }else{
          $rootScope.status = 'Inactive';
        }

        $scope.popupShow = $uibModal.open({
          animation: true,
          templateUrl: page,
          scope:$scope,
        });
    };
    $scope.closeModal = function() {
      angular.element('.modal').slideUp("fast");
      angular.element('.modal-backdrop').remove();
      angular.element('body').removeClass('modal-open');
    };
    /**
     * Change status method is use for change status of cms.
     * created on 01/12/2018
     */
    $scope.changeStatus = function () {
        if($rootScope.statusId){
            apiService.loaderShow();
              var bodyData = {
                id: $rootScope.statusId,
                status: $rootScope.status
              };
              $http.put($rootScope.baseUrl + '/content_page/change_status', bodyData)
                      .success(function (result) {
                    if (result.meta.status == true) {
                        toastr.success(result.meta.message);
                         $state.go($state.$current, null, { reload: true });
                    } else {
                        toastr.success(result.meta.message);
                    }
                    apiService.loaderHide();
              }).error(function (error) {
                    apiService.loaderHide();
                    var statusError=error.data;
                    if (statusError && statusError.meta) {
                        toastr.error(statusError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                 });
              $scope.popupShow.close();
         }
    };
  }

})();

/**
 * clinic controller handle all action related clinic.
 * @author Riya Mansuri <riya.mansuri@brainvire.com>
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.contactClinic')
            .controller('contactClinicCtrl', contactClinicCtrl);
    /** @ngInject */
    function contactClinicCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $q, $filter, $window) {

        /**
         * check permission to display list
         * created on 01/24/2018
         */
        // if (!$scope.checkPermission('CONTCT_CLINIC_LIST')) {
        //     $state.go('error-403');
        // }

        $rootScope.currentState = 'contactClinic';
        $scope.minDate = new Date().toDateString();
        var vm = this;
        $scope.vmAdded = this;

        /**
         * Search apply is use to apply filters
         * created on 01/25/2018
         */
        $scope.searchApply = function () {

            $scope.vmAdded.dtInstance.DataTable.draw();
        }
        $scope.resetSearch = function () {
            vm.phone_number = '';
            vm.fullname = '';
            vm.email = '';
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
         * Server data method is use for load data from API.
         */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/contact-clinic/list',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    phone_number: vm.phone_number ? vm.phone_number : '',
                    fullname: vm.fullname ? vm.fullname : '',
                    status: vm.status ? vm.status : '',
                    email: vm.email ? vm.email : '',
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function (result) {
                apiService.loaderHide();
                var result = result.data.data.original;
                if (result) {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                } else {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                apiService.loaderHide();
                fnCallback(records);
            }, function errorCallback(response) {
                apiService.loaderHide();
            })
        }
        ;
        /**
         * Get data table method is use get list of clinic.
         * created on 01/24/2018
         */
        $scope.getDataTable = function () {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('srNum').withTitle('Sr.No'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('id').notVisible());
            vm.dtColumns.push(DTColumnBuilder.newColumn('fullname').withTitle('Username'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('phone_number').withTitle('Phone Number'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('email').withTitle('Email'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('notes').withTitle('Notes'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('zip_code').withTitle('Zip Code'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('request_callback_datetime').withTitle('Request DateTime').renderWith($scope.getGlobalDateTimeFormat).withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Registration at').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('updated_at').withTitle('Last updated at').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            // if($scope.checkPermission('USER_UPDATE') || $scope.checkPermission('USER_STATUS') || $scope.checkPermission('USER_CHANGE_PASSWORD') || $scope.checkPermission('USER_DELETE')){
            // vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('Action').renderWith(actionHtml).withOption('className', 'tableActions').withOption('orderable', false));
            // }
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withFnServerData(serverData)
                    .withOption('serverSide', true)
                    .withPaginationType('simple_numbers')
                    .withOption('deferRender', true)
                    .withOption('searching', true)
                    .withOption('autoWidth', false)
                    .withOption('sDom', 'ZlB< "row" >rtip')
                    .withOption('bLengthChange', true)
                    .withOption('iDisplayLength', ($rootScope.numberOfRecord - 1))
                    .withOption('bInfo', true)
                    .withOption('oLanguage', {
                        "sSearch": ""
                    })
                    .withOption('pageLength', 10)
                    .withOption('createdRow', compileRow)
                    .withOption('order', [0, 'asc'])
                    .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
        /**
         * add clinic method is used for go to add clinic page.
         * created on 01/24/2018
         */
        $scope.addClinic = function () {
            $cookies.put('clinic-id', undefined);
            $state.go('add-clinic');
        }
        /**
         * edit clinic method is used for go to edit clinic page.
         * created on 01/24/2018
         */
        $scope.editClinic = function (id) {
            $cookies.put('clinic-id', id);
            $state.go('edit-clinic');
        }
        /**
         * Init complete method is use for add class on DOM of datatable.
         */
        function initComplete(row, data) {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
        }
        /**
         * Compile row method is use for compile row in angular.
         */
        function compileRow(row, data) {
            $compile(angular.element(row).contents())($scope);
        }
        /**
         * Open modal popup
         */
        $scope.open = function (page, id, status) {
            if (status == 1) {
                $rootScope.status = 'Active';
            } else {
                $rootScope.status = 'Inactive';
            }
            $rootScope.statusId = id;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };
        $scope.closeModal = function () {
            angular.element('.modal').slideUp("fast");
            angular.element('.modal-backdrop').remove();
            angular.element('body').removeClass('modal-open');
        };
        
        
        /**
         * Get edited clinic method is use for get edited clinic data.
         * created on 01/17/2018
         */
        $scope.getEditedClinic = function () {
            // if (!$scope.checkPermission('USER_CREATE') && $state.current.name == "add-user") {
            //     $state.go('error-403');
            // }
            // else if(!$scope.checkPermission('USER_UPDATE') && $state.current.name == "edit-user") {
            //     $state.go('error-403');
            // }
            if (!$state.current.name == "add-clinic") {
                $state.go('error-403');
            }
            else if(!$state.current.name == "edit-clinic") {
                $state.go('error-403');
            }
            else {
            if ($cookies.get('clinic-id') && $cookies.get('clinic-id') != undefined) {
                apiService.loaderShow();
                var vm = this;
                $http.get($rootScope.baseUrl + '/clinic/show/' + $cookies.get('clinic-id'))
                        .success(function (response) {
                            var getResponse = response.data;
                            vm.clinicId = getResponse.id;
                            vm.clinic_name = getResponse.clinic_name;
                            apiService.loaderHide();
                        }).error(function (error) {
                    var getError = error.data;
                    apiService.loaderHide();
                    if (getError && getError.meta) {
                        toastr.error(getError.meta.message);
                    } else {
                        $state.go('edit-clinic');
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                $state.go('add-clinic');
            }
        }
        };
        /**
         * Change status method is use for change status of clinic.
         * created on 01/12/2018
         */
        $scope.changeStatus = function () {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.statusId,
                    status: $rootScope.status
                };
                $http.put($rootScope.baseUrl + '/clinic/change_status', bodyData)
                        .success(function (result) {
                            if (result.meta.status == true) {
                                toastr.success(result.meta.message);
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.meta.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var statusError = error.data;
                    if (statusError && statusError.meta) {
                        toastr.error(statusError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };
        /**
         * Delete clinic method is use for delete clinic.
         * created on 01/17/2018
         */
        $scope.deleteClinic = function () {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                $http.delete($rootScope.baseUrl + '/clinic/delete/' + $rootScope.statusId)
                        .success(function (result) {
                            if (result.meta.status == true) {
                                toastr.success(result.meta.message);
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.meta.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var deleteError = error.data;
                    if (deleteError && deleteError.meta) {
                        toastr.error(deleteError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            $scope.popupShow.close();
        };

        
        /**
         * Save clinic data method is used for update clinic data.
         */

        $scope.saveClinicData = function () {
            if (!this.clinicFrm.clinic_name.$valid) {
                toastr.error("Please enter first name");
                angular.element('#clinic_name').focus();
                return;
            } 

            var bodyData = {
                clinic_name: this.clinic_name,
            };
            apiService.loaderShow();
            $scope.editedId = this.clinicId;
            if (this.clinicId) {
                $scope.saveUrl = $rootScope.baseUrl + '/clinic/update/' + this.clinicId;
                $scope.httpMethod = 'PUT';
            } else
            {
                $scope.saveUrl = $rootScope.baseUrl + '/clinic/create';
                $scope.httpMethod = 'POST';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                apiService.loaderHide();
                var responseData = response.data;
                if (responseData.meta.status == true) {
                    toastr.success(responseData.meta.message);
                    $state.go('clinic');
                } else {
                    $state.go('clinic');
                    toastr.error(responseData.meta.message);
                }
            }, function (error) {
                var errorData = error.data;
                apiService.loaderHide();
                if (errorData && errorData.meta) {
                    if (errorData.meta.message_code == 'VALIDATION_ERROR') {
                        if (errorData.errors.email) {
                            toastr.error(errorData.errors.email[0]);
                        }
                    } else {
                        toastr.error(errorData.meta.message);
                    }
                } else {
                    $state.go('clinic');
                    toastr.error("Something went wrong please try again.");
                }
            });
        };

        /**
         * Status Html method is use for prepare status badge.
         */
        function statusHtml(data) {
            var statusClass = $rootScope.getStatusClass(data);
            var statusBadge = '<span class="' + statusClass + ' font-size-14 margin-inline">' + data + '</span>';
            return statusBadge;
        }
        /**
         * Action Html method is use for prepare action html part.
         */
        function actionHtml(data, type, full) {
            var changeStatusValTo = 0;
            var editLinks = ' <a  href="javascript:void(0);" ng-click="editClinic(\'' + data + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a href="javascript:void(0);" ng-click="open(\'' + 'app/pages/common/clinic/deleteModal.html' + '\',' + data + ',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg"></i> </a>';
            var statusLinks = ' <a ng-click="open(\'' + 'app/pages/common/clinic/statusModal.html' + '\',' + data + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img class="mt-2px" src="assets/img/switch-on.png" width="24"/></a>';
            var statusClass = $rootScope.getStatusClass(full.status);
            var statusBadge = '<span class="' + statusClass + ' font-size-14 margin-inline">' + full.status + '</span>';
            if (full.status == 'Inactive') {
                changeStatusValTo = 1;
                statusLinks = ' <a ng-click="open(\'' + 'app/pages/common/clinic/statusModal.html' + '\',' + data + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img class="mt-2px" src="assets/img/switch-off.png" width="24"/></a>';
            }
            return editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
        }
    }
})();
/**
 * emailTemplate controller handle all action related emailTemplate pages.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.emailTemplate')
    .controller('emailTemplateCtrl', emailTemplateCtrl);

  /** @ngInject */
  function emailTemplateCtrl($scope, $state, $cookies, $http, apiService, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, $q) {

    /**
    * check permission to display list
    * created on 01/24/2018
    */
    // if(!$scope.checkPermission('EMAIL_TEMP_LIST')){
    //   $state.go('error-403');
    // }
    $rootScope.currentState = 'email-template';

    /**
     * Get data table method is use get list of Email Template Pages.
     * created on 01/16/2018
     */
    $scope.getDataTable = function() {
      var vm = this;
      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/email_template/list')
          .success(function(result) {
            vm.emailTemplate = [];
            var index = 1;
            var resultData=result.data;

            angular.forEach(resultData, function(value, key) {
              var editLinks = ' <a href="javascript:void(0);" ng-click="editEmailTemplate(\'' + value.id + '\')"  title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
              var statusClass = $rootScope.getStatusClass(value.status);
              var statusBadge = '<span class="'+statusClass+' font-size-14 margin-inline">'+value.status+'</span>';
              var data = {
                index: index,
                id: value.id,
                emailTemplate_title: value.email_subject,
                status: statusBadge,
                operations: editLinks
              };
              vm.emailTemplate.push(data);
              index++;
            }, vm.emailTemplate);
            defer.resolve(vm.emailTemplate);
          }).error(function(error) {
            var errorData=error.data;
            if (errorData && errorData.meta) {
              toastr.error(errorData.meta.message);
            }
          });
        return defer.promise;
      }).withPaginationType('simple_numbers');
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('oLanguage', {"sSearch": ""});
      vm.dtOptions.withOption('pageLength', 10);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
      });

      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
        DTColumnBuilder.newColumn('emailTemplate_title').withTitle('Email Subject').withOption('width', '500px'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus')
      ];
      
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
    };

    /**
     * addEmailTemplate method is use for go to add emailTemplate state .
     * created on 01/16/2018
     */
    $scope.addEmailTemplate = function() {
      $cookies.put('emailTemplate-id', undefined);
      $state.go('add-email-template');
    };
    /**
     * editEmailTemplate method is use for go to edit emailTemplate state .
     * created on 01/16/2018
     */
    $scope.editEmailTemplate = function(id) {
      $cookies.put('emailTemplate-id', id);
      $state.go('edit-email-template');
    };

    /**
     * Get edited emailTemplate method is use for get  emailTemplate data.
     * created on 01/16/2018
     */
    $scope.getEditedEmailTemplate = function() {
      if(!$state.current.name == "edit-email-template"){
        $state.go('error-403');
      }
      else {
      if ($cookies.get('emailTemplate-id') && $cookies.get('emailTemplate-id') != undefined) {
        apiService.loaderShow();
        var vm = this;
        $http.get($rootScope.baseUrl + '/email_template/show/' + $cookies.get('emailTemplate-id'))
          .success(function(response) {
            var getResponse=response.data;
            vm.emailTemplateId = getResponse.id;
            vm.emailTemplateSubject = getResponse.email_subject;
            vm.emailTemplateContent = getResponse.email_body;
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            var getError=error.data;
            if (getError && getError.meta) {
                toastr.error(getError.meta.message);
            }else {
              $state.go('edit-email-template');
              toastr.error("Something went wrong please try again.");
            }
          });
      } else {
        $state.go('add-email-template');
      }
  }
    };

    /**
     * Save email Template  method is use for save the emailTemplate data.
     * created on 01/16/2018
     */
    $scope.saveEmailTemplate = function() {
      if (!this.emailTemplateFrm.emailTemplateSubject.$valid) {
        angular.element('#emailTemplateSubject').focus();
        toastr.error("Please enter subject");
        return;
      } else if (!this.emailTemplateContent) {
        angular.element('.note-editable').focus();
        toastr.error("Please enter content");
        return;
      }
      var bodyData = {
        // page_title: this.emailTemplateSubject,
        // description: this.emailTemplateContent,
        email_subject: this.emailTemplateSubject,
        email_body: this.emailTemplateContent,
        // meta_keywords:'About',
        // meta_description:'About',
        status:'Active'
      };
      apiService.loaderShow();
        $scope.saveUrl = $rootScope.baseUrl + '/email_template/create';
        $scope.httpMethod = 'POST';
        $scope.editedId = this.emailTemplateId;
        if (this.emailTemplateId) {
          $scope.saveUrl = $rootScope.baseUrl + '/email_template/update/' + this.emailTemplateId;
          $scope.httpMethod = 'PUT';
        }
        $http({
          url: $scope.saveUrl,
          method: $scope.httpMethod,
          data: $scope.dataUrlEncode(bodyData),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(response) {
          apiService.loaderHide();
          var responseData = response.data;
          if (responseData && responseData.meta.status == true) {
            toastr.success(responseData.meta.message);
            $state.go('email-template');
          } else {
            $state.go('email-template');
            toastr.error(responseData.meta.message);
          }
        }, function(error) {
          apiService.loaderHide();
          var errorData=error.data;
          if (errorData && errorData.meta) {
            toastr.error(errorData.meta.message);
          }else {
            $state.go('email-template');
            toastr.error("Something went wrong please try again.");
          }
        });
    };
  }

})();

/**
 * error403Ctrl controller is used to display error page.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.error403')
    .controller('error403Ctrl', error403Ctrl);

  /** @ngInject */
  function error403Ctrl($scope,$rootScope) {
    $rootScope.currentState='dashboard';
  }

})();

/**
 * FAQ controller handle all action related FAQ pages.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.faq')
    .controller('faqCtrl', faqCtrl);

  /** @ngInject */
  function faqCtrl($scope, $state, $cookies, $http, apiService, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, $q, $uibModal) {

    /**
    * check permission to display list
    * created on 01/24/2018
    */
    if(!$scope.checkPermission('FAQ_LIST')){
      $state.go('error-403');
    }
    $rootScope.currentState = 'faq-management';

    /**
     * Get data table method is use get list of FAQ Pages.
     * created on 01/12/2018
     */
    $scope.getDataTable = function() {
      var vm = this;
      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/faq/list')
          .success(function(result) {
            vm.faq = [];
            var index = 1;
            var resultData=result.data;
            angular.forEach(resultData, function(value, key) {
              var changeStatusValTo = 0;
              var editLinks = ' <a ng-if="checkPermission(\''+'FAQ_UPDATE'+'\')" href="javascript:void(0);" ng-click="editFAQ(\'' + value.id + '\')"  title="Edit"><i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i></a>';
              var deleteLinks = '  <a ng-if="checkPermission(\''+'FAQ_DELETE'+'\')" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/common/faq/deleteModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg"></i> </a>';
              var statusLinks = ' <a ng-if="checkPermission(\''+'FAQ_STATUS'+'\')" ng-click="open(\'' + 'app/pages/common/faq/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img class="mt-2px" src="assets/img/switch-on.png" width="24"/></a>';
              var statusClass = $rootScope.getStatusClass(value.status);
              var statusBadge = '<span class="'+statusClass+' font-size-14 margin-inline">'+value.status+'</span>';

              if (value.status == 'Inactive') {
                  changeStatusValTo = 1;
                  statusLinks = ' <a ng-if="checkPermission(\''+'FAQ_STATUS'+'\')" ng-click="open(\'' + 'app/pages/common/faq/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img class="mt-2px" src="assets/img/switch-off.png" width="24"/></a>';
              }
              var data = {
                index: index,
                id: value.id,
                question: value.question,
                faq_status:statusBadge,
                faq_topic:value.faq_topic.topic_name,
                created_at:value.created_at,
                operations: editLinks+ '&nbsp;' + statusLinks+ '&nbsp;' + deleteLinks
              };
              vm.faq.push(data);
              index++;
            }, vm.faq);
            defer.resolve(vm.faq);
          }).error(function(error) {
            var errorData=error.data;
            if (errorData && errorData.meta) {
              toastr.error(errorData.meta.message);
            }
          });
        return defer.promise;
      }).withPaginationType('simple_numbers');
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('oLanguage', {"sSearch": ""});
      vm.dtOptions.withOption('pageLength', 10);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
      });

      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
        DTColumnBuilder.newColumn('question').withTitle('Question').renderWith(apiService.ellipsisString),
        DTColumnBuilder.newColumn('faq_topic').withTitle('FAQ Topic'),
        DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
        DTColumnBuilder.newColumn('faq_status').withTitle('Status').withOption('className', 'tableStatus')
      ];
      if($scope.checkPermission('FAQ_UPDATE') || $scope.checkPermission('FAQ_STATUS') || $scope.checkPermission('FAQ_DELETE')){
          vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }
    }

    /**
     * addFAQ method is use for go to add faq state .
     * created on 01/12/2018
     */
    $scope.addFAQ = function() {
      $cookies.put('faq-id', undefined);
      $state.go('add-faq');
    }
    /**
     * editFAQ method is use for go to edit faq state .
     * created on 01/12/2018
     */
    $scope.editFAQ = function(id) {
      $cookies.put('faq-id', id);
      $state.go('edit-faq');
    }

    /**
     * Get edited faq method is use for get  faq data.
     * created on 01/12/2018
     */
    $scope.getEditedFAQ = function() {
      if(!$scope.checkPermission('FAQ_CREATE') && $state.current.name == "add-faq"){
        $state.go('error-403');
      }
      else if(!$scope.checkPermission('FAQ_UPDATE') && $state.current.name == "edit-faq") {
          $state.go('error-403');
      }
      else {
      if ($cookies.get('faq-id') && $cookies.get('faq-id') != undefined) {
        apiService.loaderShow();
        var vm = this;
        $http.get($rootScope.baseUrl + '/faq/show/' + $cookies.get('faq-id'))
          .success(function(response) {
            var getResponse=response.data;
            vm.faqId = getResponse.id;
            vm.faqQuestion = getResponse.question;
            vm.faqAnswer = getResponse.answer;
            //vm.faqTopic = getResponse.faq_topic_id;
            vm.faqTopic=''+getResponse.faq_topic_id+'';
            vm.faqStatus = getResponse.status;
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            var getError=error.data;
            if (getError && getError.meta) {
                toastr.error(getError.meta.message);
            }else {
              $state.go('edit-faq');
              toastr.error("Something went wrong please try again.");
            }
          });
      } else {
        $state.go('add-faq');
      }
    }
      this.faqTopic = '0';
    };
    /**
    * Get data of faq topics dropdown.
    * created on 01/12/2018
    */
    $scope.getFAQTopic = function() {
       $scope.standardSelectItems = [
         {value: '0', label: 'Select FAQ Topic'},
       ];
       $http.get($rootScope.baseUrl + '/faq_topic/list')
           .success(function (response) {
           angular.forEach(response.data, function (value, key) {
               $scope.standardSelectItems.push({value:value.id, label: value.topic_name})
           });
       }).error(function (response) {
    //     toastr.error("Something went wrong please try again.");
       });
     }
    /**
     * Save FAQ  method is use for save the faq data.
     * created on 01/12/2018
     */
    $scope.saveFAQ = function() {
      var faq = angular.element('.faqData').val();
      if (faq=='0') {
        angular.element('#faqTopic').focus();
        toastr.error("Please select faq topic");
        return;
      }else if (!this.faqFrm.faqQuestion.$valid) {
        angular.element('#faqQuestion').focus();
        toastr.error("Please enter question");
        return;
      } else if (!this.faqFrm.faqAnswer.$valid) {
        angular.element('#faqAnswer').focus();
        toastr.error("Please enter answer");
        return;
      }else if (!this.faqFrm.faqStatus.$valid) {
        angular.element('#status').focus();
        toastr.error("Please select faq status");
        return;
      }
      var bodyData = {
        faq_topic_id: this.faqTopic,
        question: this.faqQuestion,
        answer:this.faqAnswer,
        status:this.faqStatus
      };
      apiService.loaderShow();
        $scope.saveUrl = $rootScope.baseUrl + '/faq/create';
        $scope.httpMethod = 'POST';
        $scope.editedId = this.faqId;
        if (this.faqId) {
          $scope.saveUrl = $rootScope.baseUrl + '/faq/update/' + this.faqId;
          $scope.httpMethod = 'PUT';
        }
        $http({
          url: $scope.saveUrl,
          method: $scope.httpMethod,
          data: $scope.dataUrlEncode(bodyData),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(response) {
          apiService.loaderHide();
          var responseData = response.data;
          if (responseData && responseData.meta.status == true) {
            toastr.success(responseData.meta.message);
            $state.go('faq-management');
          } else {
            $state.go('faq-management');
            toastr.success(responseData.meta.message);
          }
        }, function(error) {
          apiService.loaderHide();
          var errorData=error.data;
          if (errorData && errorData.meta) {
              toastr.error(errorData.meta.message);
          }else {
            $state.go('faq-management');
            toastr.error("Something went wrong please try again.");
          }
        });
    };
    /**
     * Open model.
     * created on 01/12/2018
     */
    $scope.open = function (page,id,status) {
        $rootScope.statusId = id;
        if(status==1){
          $rootScope.status = 'Active';
        }else{
          $rootScope.status = 'Inactive';
        }

        $scope.popupShow = $uibModal.open({
          animation: true,
          templateUrl: page,
          scope:$scope,
        });
    };
    $scope.closeModal = function() {
      angular.element('.modal').slideUp("fast");
      angular.element('.modal-backdrop').remove();
      angular.element('body').removeClass('modal-open');
    };
    /**
     * Change status method is use for change status of faq.
     * created on 01/12/2018
     */
    $scope.changeStatus = function () {
        if($rootScope.statusId){
            apiService.loaderShow();
              var bodyData = {
                id: $rootScope.statusId,
                status: $rootScope.status
              };
              $http.put($rootScope.baseUrl + '/faq/change_status', bodyData)
                      .success(function (result) {
                    if (result.meta && result.meta.status == true) {
                        toastr.success(result.meta.message);
                         $state.go($state.$current, null, { reload: true });
                    } else {
                        toastr.success(result.meta.message);
                    }
                    apiService.loaderHide();
              }).error(function (error) {
                    apiService.loaderHide();
                    var statusError=error.data;
                    if (statusError && statusError.meta) {
                        toastr.error(statusError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                 });
              $scope.popupShow.close();
         }
    };
    /**
     * Delete faq method is use for delete faq.
     * created on 01/12/2018
     */
    $scope.deleteFAQ = function() {
      if ($rootScope.statusId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/faq/delete/' + $rootScope.statusId)
                .success(function(result) {
                  if (result.meta && result.meta.status == true) {
                      toastr.success(result.meta.message);
                       $state.go($state.$current, null, { reload: true });
                  } else {
                      toastr.success(result.meta.message);
                  }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            var deleteError=error.data;
            if (deleteError && deleteError.meta) {
                toastr.error(deleteError.meta.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };
  }

})();

/**
 * hearing controller handle all action related hearing.
 * @author Riya Mansuri <riya.mansuri@brainvire.com>
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.hearing')
            .controller('hearingCtrl', clinicCtrl);
    /** @ngInject */
    function clinicCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $q, $filter, $window) {

        /**
         * check permission to display list
         * created on 01/24/2018
         */
        // if (!$scope.checkPermission('USER_LIST')) {
        //     $state.go('error-403');
        // }

        $rootScope.currentState = 'hearing';
        $scope.minDate = new Date().toDateString();
        var vm = this;
        $scope.vmAdded = this;

        /**
         * Search apply is use to apply filters
         * created on 01/25/2018
         */
        $scope.searchApply = function () {

            $scope.vmAdded.dtInstance.DataTable.draw();
        }
        $scope.resetSearch = function () {
            vm.name = '';
            vm.fullname = '';
            vm.uuid = '';
            vm.user_id = '';
            $cookies.remove("user-id");
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
         * Server data method is use for load data from API.
         */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            if ($cookies.get("user-id") && $cookies.get("user-id") != undefined) {
                $scope.vm.user_id = $cookies.get("user-id");
            }

            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/hearing-test/listing',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    name: vm.name ? vm.name : '',
                    fullname: vm.fullname ? vm.fullname : '',
                    uuid: vm.uuid ? vm.uuid : '',
                    user_id: $scope.vm.user_id ? $scope.vm.user_id : '',
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function (result) {
                apiService.loaderHide();
                var result = result.data.data.original;
                if ($cookies.get("user-id") && $cookies.get("user-id") != undefined) {
                    $cookies.remove("user-id");
                    $scope.vm.fullname = result.data[0].fullname;
                }

                if (result) {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                    
                } else {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }

                apiService.loaderHide();
                fnCallback(records);
            }, function errorCallback(response) {
                apiService.loaderHide();
            })
        }
        ;
        /**
         * Get data table method is use get list of clinic.
         * created on 01/24/2018
         */
        $scope.getDataTable = function () {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('srNum').withTitle('Sr.No'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('id').notVisible());
            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Name'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('fullname').withTitle('Username'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('uuid').withTitle('UUID'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('result_range').withTitle('Test Result'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('frequency').withTitle('Frequency'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Registration at').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            // vm.dtColumns.push(DTColumnBuilder.newColumn('updated_at').withTitle('Last updated at').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            // if($scope.checkPermission('USER_UPDATE') || $scope.checkPermission('USER_STATUS') || $scope.checkPermission('USER_CHANGE_PASSWORD') || $scope.checkPermission('USER_DELETE')){
            vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('Action').renderWith(actionHtml).withOption('className', 'tableActions').withOption('orderable', false));
            // }
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withFnServerData(serverData)
                    .withOption('serverSide', true)
                    .withPaginationType('simple_numbers')
                    .withOption('deferRender', true)
                    .withOption('searching', true)
                    .withOption('autoWidth', false)
                    .withOption('sDom', 'ZlB< "row" >rtip')
                    .withOption('bLengthChange', true)
                    .withOption('iDisplayLength', ($rootScope.numberOfRecord - 1))
                    .withOption('bInfo', true)
                    .withOption('oLanguage', {
                        "sSearch": ""
                    })
                    .withOption('pageLength', 10)
                    .withOption('createdRow', compileRow)
                    .withOption('order', [1, 'desc'])
                    .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
        /**
         * add clinic method is used for go to add clinic page.
         * created on 01/24/2018
         */
        $scope.addClinic = function () {
            $cookies.put('clinic-id', undefined);
            $state.go('add-clinic');
        }
        /**
         * edit clinic method is used for go to edit clinic page.
         * created on 01/24/2018
         */
        $scope.viewHearing = function (id) {
            $cookies.put('hearing-id', id);
            $state.go('show-hearing');
        }
        /**
         * Init complete method is use for add class on DOM of datatable.
         */
        function initComplete(row, data) {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
        }
        /**
         * Compile row method is use for compile row in angular.
         */
        function compileRow(row, data) {
            $compile(angular.element(row).contents())($scope);
        }
        /**
         * Open modal popup
         */
        $scope.open = function (page, id, status) {
            if (status == 1) {
                $rootScope.status = 'Active';
            } else {
                $rootScope.status = 'Inactive';
            }
            $rootScope.statusId = id;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };
        $scope.closeModal = function () {
            angular.element('.modal').slideUp("fast");
            angular.element('.modal-backdrop').remove();
            angular.element('body').removeClass('modal-open');
        };
        
        
        /**
         * Get edited hearing method is use for get edited hearing data.
         * created on 01/17/2018
         */
        $scope.getViewedHearing = function () {
            // if (!$scope.checkPermission('USER_CREATE') && $state.current.name == "add-user") {
            //     $state.go('error-403');
            // }
            // else if(!$scope.checkPermission('USER_UPDATE') && $state.current.name == "edit-user") {
            //     $state.go('error-403');
            // }
            if(!$state.current.name == "show-hearing") {
                $state.go('error-403');
            }
            else {
            if ($cookies.get('hearing-id') && $cookies.get('hearing-id') != undefined) {
                apiService.loaderShow();
                var vm = this;
                $http.get($rootScope.baseUrl + '/hearing-test/show/' + $cookies.get('hearing-id'))
                        .success(function (response) {
                            var getResponse = response.data;
                            vm.hearingId = getResponse.id;
                            vm.name = getResponse.name;
                            vm.frequency = getResponse.frequency;
                            vm.decibel = getResponse.decibel;
                            vm.result_range = getResponse.result_range;
                            vm.description = getResponse.description;

                            /* Chart integrate for frequency and decibel */
                            $scope.labels = getResponse.result.labels;
                            $scope.data = [
                              getResponse.result.data
                            ];
                            $scope.series = getResponse.result.series;
                            apiService.loaderHide();
                        }).error(function (error) {
                    var getError = error.data;
                    apiService.loaderHide();
                    if (getError && getError.meta) {
                        toastr.error(getError.meta.message);
                    } else {
                        $state.go('hearing');
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                $state.go('hearing');
            }
        }
        };
        /**
         * Change status method is use for change status of hearing.
         * created on 01/12/2018
         */
        $scope.changeStatus = function () {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.statusId,
                    status: $rootScope.status
                };
                $http.put($rootScope.baseUrl + '/hearing/change_status', bodyData)
                        .success(function (result) {
                            if (result.meta.status == true) {
                                toastr.success(result.meta.message);
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.meta.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var statusError = error.data;
                    if (statusError && statusError.meta) {
                        toastr.error(statusError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };

        /**
         * Status Html method is use for prepare status badge.
         */
        function statusHtml(data) {
            var statusClass = $rootScope.getStatusClass(data);
            var statusBadge = '<span class="' + statusClass + ' font-size-14 margin-inline">' + data + '</span>';
            return statusBadge;
        }
        /**
         * Action Html method is use for prepare action html part.
         */
        function actionHtml(data, type, full) {
            var changeStatusValTo = 0;
            var showLinks = ' <a  href="javascript:void(0);" ng-click="viewHearing(\'' + data + '\')" title="View"><i class="fa fa-eye fa-lg white" aria-hidden="true"></i></a>';
            return showLinks
        }
    }
})();
/**
 * Login page controller handle all action related user authentication.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.login')
    .controller('loginCtrl', loginCtrl);

  /** @ngInject */
  function loginCtrl($state,$scope, $rootScope, $http, toastr, apiService, $window, $uibModal,$cookies) {

    /**
     * Login method is used for login into system
     * created on 01/10/2018
     */
     var vm=this;
     $scope.emailAdd = $cookies.get("userName");
     $scope.password = $cookies.get("password");
     $scope.rememberme = $cookies.get("remember");
     if($scope.rememberme){
       $scope.rememberme=JSON.parse($scope.rememberme);
     }
    $scope.login = function() {
      var username = $.trim(this.emailAdd);
      var password = this.password;
      if ($scope.loginFrm.emailAdd.$error.required) {
        angular.element('#inputEmail').focus();
        toastr.error("Please enter email");
        return;
      }else if ($scope.loginFrm.emailAdd.$error.pattern) {
        angular.element('#inputEmail').focus();
        toastr.error("Please enter valid email");
        return;
      }else if ($scope.loginFrm.password.$error.required) {
        angular.element('#inputPassword').focus();
        toastr.error("Please enter password");
        return;
      }
      apiService.loaderShow();
      angular.element('.btn-login').attr('disabled', 'disabled');
      var bodyData = {
        email: username.toLowerCase(),
        password: this.password?this.password:'',
        user_type: 'ADMIN'
      };

      $http({
        url: $rootScope.baseUrl + '/oauth/signin',
        method: "POST",
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var responseData=response.data;
        var user_detail=responseData.data.user_detail;
        if (responseData && responseData.meta && responseData.meta.status === true) {
          $rootScope.globals = {
            currentUser: {
              email: user_detail.email,
              username: user_detail.username,
              firstname: user_detail.first_name,
              lastname: user_detail.last_name,
              userRole: user_detail.role,
              permission:user_detail.permission,
              profile_image: user_detail.profile_image,
              access_token: responseData.data.access_token,
              token_type: responseData.data.token_type,
              expires_in: responseData.data.expires_in,
              refresh_token:responseData.data.refresh_token
              //id: response.data.id
            }
          };
          $rootScope.permissionArr = user_detail.permission;
          $rootScope.userRole=user_detail.role;
          $window.localStorage.setItem('globals', apiService.encriptData($rootScope.globals));
          $http.defaults.headers.common['Authorization'] = responseData.data.token_type+' ' + responseData.data.access_token; // set authorization
          if ($scope.rememberme===true) {
              $cookies.put("userName", username);
              $cookies.put("password", password);
              $cookies.put("remember", true);
          }else{
            $cookies.remove("userName");
            $cookies.remove("password");
            $cookies.remove("remember");
          }
          $rootScope.currentState = 'dashboard';
          $state.go('dashboard');
          toastr.success(responseData.meta.message);
        } else {
          if (responseData.meta) {
              toastr.error(responseData.meta.message);
          } else {
            $state.go('login');
            toastr.error("Something went wrong please try again.");
          }
        }
        angular.element('.btn-login').prop("disabled", false);
      }, function(error) {
        apiService.loaderHide();
        var errorData=error.data;
        angular.element('.btn-login').prop("disabled", false);
        if (errorData && errorData.meta) {
          if (errorData.meta.message_code == 'VALIDATION_ERROR') {
            if(errorData.errors.email){
              toastr.error(errorData.errors.email[0]);
            }else if(errorData.errors.password){
              toastr.error(errorData.errors.password[0]);
            }else{
              toastr.error(errorData.meta.message);
            }
          } else{
            toastr.error(errorData.meta.message);
          }
        } else {
          $state.go('login');
          toastr.error("Something went wrong please try again.");
        }
      });
    };
    /**
     * goToForgotPassword Method is used to  open forgot password modal
     * created on 01/18/2018
     */
    $scope.goToForgotPassword = function() {
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/common/login/forgotPassword.html',
        scope: $scope,
      });
    }

    /**
     * forgotPassword Method is used to Sent reset password link to registered mail
     * created on 01/18/2017
     */
    $scope.forgotPassword = function() {
      if (this.forgotPasswordFrm.emailAddForgotpass.$error.required) {
        angular.element('#inputEmailFrgt').focus();
        toastr.error("Please enter email");
        return;
      }else if (this.forgotPasswordFrm.emailAddForgotpass.$error.pattern) {
        angular.element('#inputEmailFrgt').focus();
        toastr.error("Please enter valid email");
        return;
      }
      apiService.loaderShow();
      var bodyData = {
        email: this.emailAddForgotpass,
        user_type: 'ADMIN',
        role: 'ADMIN'
      };
      $http.post($rootScope.baseUrl + '/oauth/admin/password/forgot', bodyData)
        .success(function(result) {
          var responseData = result;
          apiService.loaderHide();
          if (responseData && responseData.meta.status == true) {
            toastr.success(responseData.meta.message);
            $scope.popupShow.close();
          } else {
            toastr.error(responseData.meta.message);
          }
        }).error(function(error) {
          apiService.loaderHide();
          if (error && error.meta) {
              toastr.error(error.meta.message);
          } else {
              toastr.error("Something went wrong please try again.");
          }
        });
    };
  }
})();

/**
 * privacyCtrl controller is used to display error page.
 * @author Parth Gajjar <parth.gajjar@brainvire.com>
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.privacy')
    .controller('privacyCtrl', privacyCtrl);

  /** @ngInject */
  function privacyCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $q, $filter, $window) {
    $rootScope.currentState='privacy';
    document.body.classList.add('static-page');

    $scope.getPrivacy = function () {
    	var vm = this;
    	$http.get($rootScope.baseUrl + '/content/privacy-policy')
                .success(function (response) {
                    var getResponse = response.data;
                    vm.id = getResponse.id;
                    vm.description = getResponse.description;
                    apiService.loaderHide();
                }).error(function (error) {
            var getError = error.data;
            apiService.loaderHide();
            if (getError && getError.meta) {
                toastr.error(getError.meta.message);
            } else {
                $state.go('terms');
                toastr.error("Something went wrong please try again.");
            }
        });
    }
  }

})();

/**
 * @author Harsha Prajapati<harsha.prajapati@brainvire.com>
 * created on 01/16/2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('profileCtrl', profileCtrl);

  /** @ngInject */
  function profileCtrl($scope, $state, toastr , $cookies, $rootScope, apiService, $http) {

    $rootScope.currentState = 'dashboard';
    /**
    * Get user profile method is use for get user profile data.
    * created on 01/24/2018
    */
    $scope.getUserProfile = function() {
         apiService.loaderShow();
         $http.get($rootScope.baseUrl+'/user/profile')
        .success(function (response) {
            if(response.meta && response.meta.status == true){
                var responseData=response.data;
                $scope.firstname = responseData.first_name;
                $scope.lastname = responseData.last_name;
                $scope.email = responseData.email;
                $scope.username = responseData.username;
            }else{
                $rootScope.globals = {};
                $cookies.remove('globals');
                toastr.warning(response.meta.message);
                $state.go('login');
            }
            apiService.loaderHide();
        }).error(function (response) {
          apiService.loaderHide();
          var getError=error.data;
          if (getError && getError.meta) {
              toastr.error(getError.meta.message);
          }else {
            toastr.error("Something went wrong please try again.");
          }
        });
      };

    /**
    * Update user profile method is use for update user profile data.
    * created on 01/24/2018
    */
    $scope.updateUserProfile = function() {
        if (this.profileFrm.firstname.$error.required) {
            toastr.error("Please enter first name");
            angular.element('#firstname').focus();
            return;
        }else if (this.profileFrm.firstname.$error.pattern) {
            toastr.error("Please enter valid first name");
            angular.element('#firstname').focus();
            return;
        }else if (this.profileFrm.lastname.$error.required) {
            toastr.error("Please enter last name");
             angular.element('#lastname').focus();
            return;
        }else if (this.profileFrm.lastname.$error.pattern) {
            toastr.error("Please enter valid last name");
             angular.element('#lastname').focus();
            return;
        }
        $rootScope.baseUrl = $rootScope.host+'/api';
        apiService.loaderShow();
        var bodyData = {
            first_name :this.firstname,
            last_name :this.lastname
        };
        $http({
            url: $rootScope.baseUrl+'/subadmin/update_profile',
            method: "PUT",
            data: $scope.dataUrlEncode(bodyData),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (response) {
            var responseData=response.data;
            if (responseData.meta.status == true) {
                toastr.success(responseData.meta.message);
                $state.go($state.$current, null, { reload: true });
            }else{
                toastr.success(responseData.meta.message);
            }
            apiService.loaderHide();
        }, function (error) {
             apiService.loaderHide();
             var profileError=error.data;
             if (profileError && profileError.meta) {
                 toastr.error(profileError.meta.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
        });
    }

    /**
    * Change user password method is use for change user password.
    * created on 01/18/2018
    */
    $scope.changeUserPassword = function() {
        var vm=this;
        if (this.changePwdFrm.opassword.$error.required) {
            toastr.error("Please enter old password");
            angular.element('#opassword').focus();
            return;
        }else if (this.changePwdFrm.opassword.$error.pattern) {
            toastr.error("Password should be 8 characters with number combination");
            angular.element('#opassword').focus();
            return;
        }else if (this.changePwdFrm.npassword.$error.required) {
            toastr.error("Please enter new password");
            angular.element('#npassword').focus();
            return;
        }else if (this.changePwdFrm.npassword.$error.pattern) {
            toastr.error("Password should be 8 characters with number combination");
            angular.element('#npassword').focus();
            return;
        }else if (this.changePwdFrm.cpassword.$error.required) {
            toastr.error("Please enter confirm password");
            angular.element('#cpassword').focus();
            return;
        }else if (this.changePwdFrm.cpassword.$error.pattern) {
            toastr.error("Confirm Password should match with password");
            angular.element('#cpassword').focus();
            return;
        }
        apiService.loaderShow();
        var bodyData = {
            old_password: this.oldPassword,
            new_password:  this.newPassword,
            confirm_password:  this.confirmPassword
        };
        $http({
            url: $rootScope.baseUrl+'/oauth/password/change',
            method: "PUT",
            data: $scope.dataUrlEncode(bodyData),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (response) {
          var responseData=response.data;
          if (responseData.meta.status == true) {
              toastr.success(responseData.meta.message);
              vm.oldPassword = '';
              vm.newPassword = '';
              vm.confirmPassword = '';
              $state.go($state.$current, null, { reload: true });
          } else {
              toastr.error("Something went wrong please try again.");
          }
           apiService.loaderHide();
        }, function (error) {
          apiService.loaderHide();
          var passError=error.data;
          if (passError && passError.meta) {
              toastr.error(passError.meta.message);
          } else {
              toastr.error("Something went wrong please try again.");
          }
        });

    }

  }

})();

/**
 * resetPasswordCtrl controller is used to reset the password.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.resetPassword')
    .controller('resetPasswordCtrl', resetPasswordCtrl);

  /** @ngInject */
  function resetPasswordCtrl($scope, $rootScope, $uibModal, $location, $state, $cookies, $http, toastr, apiService, $window) {

    var searchObject = $location.search();
    /**
     * validate reset password
     * created on 01/19/2018
     */
     $scope.validateResetPass = function() {
        var bodyData = {
          token: searchObject.t
        };
        $http({
          url: $rootScope.baseUrl + '/oauth/password/validate_reset_token',
          method: "POST",
          data: $scope.dataUrlEncode(bodyData),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(response) {

        }, function(error) {
          var errorData=error.data;
          if (errorData && errorData.meta) {
              toastr.error(errorData.meta.message);
              $state.go('login');
            }
        });
        };
    /**
     * ResetPass Method is used to  reset the new  password
     * created on 01/18/2018
     */
    $scope.resetPass = function() {
      if (this.resetPassFrm.newPassword.$error.required) {
        toastr.error("Please enter new password");
        angular.element('#newPassword').focus();
        return;
      }else if (this.resetPassFrm.newPassword.$error.pattern) {
        toastr.error("Password should be 8 characters with number combination");
        angular.element('#newPassword').focus();
        return;
      } else if (this.resetPassFrm.confirmPassword.$error.required) {
        toastr.error("Please enter confirm password");
        angular.element('#confirmPassword').focus();
        return;
      }else if (this.resetPassFrm.confirmPassword.$error.pattern) {
        toastr.error("Confirm Password should match with password");
        angular.element('#confirmPassword').focus();
        return;
      }

      apiService.loaderShow();
      var bodyData = {
        token: searchObject.t,
        new_password: this.newPassword,
        confirm_password:this.confirmPassword
      };
      $http.put($rootScope.baseUrl + '/oauth/password/reset', bodyData)
        .success(function(response) {
          if (response.meta && response.meta.status == true) {
            toastr.success(response.meta.message);
            $state.go('login');
          } else {
            toastr.success(response.meta.message);
          }
          apiService.loaderHide();
        }).error(function(error) {
          apiService.loaderHide();
          if (error && error.meta) {
              toastr.error(error.meta.message);
          } else {
              toastr.error("Something went wrong please try again.");
          }
        });
    };
  }

})();

/**
 * @author Rahul
 * created on 01/10/2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.rolePermission')
    .controller('rolePermissionCtrl', rolePermissionCtrl);

  /**
   * @ngInject
   * @param {type} $scope
   * @param {type} $timeout
   * @returns {undefined}
   */
  function rolePermissionCtrl($scope, $state, $cookies, $http, $rootScope, apiService, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, $q, $timeout, $uibModal) {

    /**
    * check permission to display list
    * created on 01/24/2018
    */
    if(!$scope.checkPermission('ROLE_PERMISSION_LIST')){
      $state.go('error-403');
    }
    $rootScope.currentState = 'admin-permissions';
    $scope.ignoreChanges    = false;
    $scope.newNode          = {};
    $scope.pgmTitle         = 'Add New Role';

    $scope.basicConfig = {
      core: {
        multiple: true,
        check_callback: true,
        worker: true,
        animation: true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        }
      },
      plugins : ['types','checkbox'],
      'version': 1
    };

    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      $scope.permissionData = $scope.permissionData;
      $scope.basicConfig.version++;
    };
    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.permissionData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.permissionData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    /**
     * get the List of role wise permission
     * created on 01/23/2018
     */
    $scope.getPermissionList = function(id) {
      if(id!='0'){
        $rootScope.role_id=id;
        var bodyData = {
          role_id: id
        };
        $http({
          url: $rootScope.baseUrl + '/permission/list',
          method: "POST",
          data: $scope.dataUrlEncode(bodyData),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(response) {
          var responseData=response.data;
          if (responseData.meta.status == true) {
            $scope.permissionData=responseData.data;
            $scope.ignoreChanges = true;
            $scope.basicConfig.version++;
          }
        }, function(error) {
          var errorData=error.data;
          if (errorData && errorData.meta) {
              toastr.error(errorData.meta.message);
            }
        });
      }
    };

    /**
     * save permission is use to save role wise permission
     * created on 01/23/2018
     */
    $scope.savePermission = function() {
      if ($rootScope.role_id && $rootScope.role_id != undefined) {
        var permId = [];
        var selected_node = $scope.treeInstance.jstree(true).get_selected();
        var perlen     = selected_node.length;
        for(var i=0; i<= perlen; i++) {
            if(isNaN(selected_node[i]) == false) {
                permId.push(selected_node[i]);
            }
        }
        apiService.loaderShow();
        var bodyData = {
          permission_key: permId
        };
        $http({
          url: $rootScope.baseUrl + '/permission/role_assign/'+$rootScope.role_id,
          method: "POST",
          data: $scope.dataUrlEncode(bodyData),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(response) {
          var responseData=response.data;
          if (responseData && responseData.meta.status == true) {
            toastr.success(responseData.meta.message);
          }
          apiService.loaderHide();
        }, function(error) {
          apiService.loaderHide();
          var errorData=error.data;
          if (errorData && errorData.meta) {
              toastr.error(errorData.meta.message);
            }
        });
      }else{
        toastr.error("Please select role");
      }
    };
    /**
     * Get data table method is use get list of Roles.
     * created on 01/23/2018
     */
    $scope.getDataRoleTable = function() {
      var vm = this;
      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/role/list')
          .success(function(result) {
            vm.role = [];
            var index = 1;
            var resultData=result.data;
            $scope.adminRoles=resultData;
            angular.forEach(resultData, function(value, key) {
              var changeStatusValTo = 0;
              var editLinks = ' <a ng-if="checkPermission(\''+'ROLE_UPDATE'+'\')" href="javascript:void(0);" ng-click="editRole(\'' + value.id + '\', \'' + value.name + '\')"  title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
              var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
              var statusLinks = '<a ng-if="checkPermission(\''+'ROLE_STATUS'+'\')" ng-click="openModal(\'' + 'app/pages/common/rolePermission/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img class="mt-2px" src="assets/img/switch-on.png" width="24"/></a>';

              if (value.status == 'Inactive') {
                  changeStatusValTo = 1;
                  statusBadge = '<span class="label label-danger font-size-14 margin-inline">Inactive</span>';
                  statusLinks = '<a ng-if="checkPermission(\''+'ROLE_STATUS'+'\')" ng-click="openModal(\'' + 'app/pages/common/rolePermission/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img class="mt-2px" src="assets/img/switch-off.png" width="24"/></a>';
              }
              var data = {
                index: index,
                id: value.id,
                role_title: value.name,
                role_status:statusBadge,
                operations: editLinks+ '&nbsp;' + statusLinks
              };
              vm.role.push(data);
              index++;
            }, vm.role);
            defer.resolve(vm.role);
          }).error(function(error) {
            var errorData=error.data;
            if (errorData && errorData.meta) {
              toastr.error(errorData.meta.message);
            }
          });
        return defer.promise;
      }).withPaginationType('simple_numbers');
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('oLanguage', {"sSearch": ""});
      vm.dtOptions.withOption('pageLength', 10);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
      });

      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
        DTColumnBuilder.newColumn('role_title').withTitle('Role'),
        DTColumnBuilder.newColumn('role_status').withTitle('Status').withOption('className', 'tableStatus')
      ];
      if($scope.checkPermission('ROLE_UPDATE') || $scope.checkPermission('ROLE_STATUS')){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));  
      }
    };

    /**
     * Open model.
     * created on 01/23/2018
     */
    $scope.openModal = function (page,id,status) {
        $rootScope.statusId = id;
        if ( status == 1 ){
           $rootScope.status = 'Active';
        }else{
           $rootScope.status = 'Inactive';
        }

        $scope.popupShow = $uibModal.open({
          animation: true,
          templateUrl: page,
          scope:$scope
        });
    };
    $scope.closeModal = function() {
      angular.element('.modal').slideUp("fast");
      angular.element('.modal-backdrop').remove();
      angular.element('body').removeClass('modal-open');
    };

    /**
     * Change status method is use for change status of role.
     * created on 01/23/2018
     */
    $scope.changeStatus = function () {
        if($rootScope.statusId) {
            apiService.loaderShow();
              var bodyData = {
                id: $rootScope.statusId,
                status: $rootScope.status
              };
              $http.put($rootScope.baseUrl + '/role/change_status', bodyData)
                      .success(function (result) {
                    if (result.meta && result.meta.status == true) {
                        toastr.success(result.meta.message);
                         $state.go($state.$current, null, { reload: true });
                    }else{
                        toastr.success(result.meta.message);
                    }
                    apiService.loaderHide();
              }).error(function (error) {
                    apiService.loaderHide();
                    var statusError=error.data;
                    if (statusError && statusError.meta) {
                        toastr.error(statusError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                 });
                $scope.popupShow.close();
         }
    };

    /**
     * addRole method.
     * created on 01/23/2018
     */
    $scope.addRole = function() {
      $cookies.put('role-id', undefined);
      $scope.pgmTitle = 'Add New Role';
      $scope.roleName = '';
      $scope.popupShow = $uibModal.open({
          animation: true,
          templateUrl: 'app/pages/common/rolePermission/addModal.html',
          scope:$scope
        });
    };
    /**
     * editRole method.
     * created on 01/23/2018
     */
    $scope.editRole = function(id,name) {
      $cookies.put('role-id', id);
      $scope.roleName = name;
      $scope.pgmTitle = 'Update Role [' + name + ']';
      $scope.popupShow = $uibModal.open({
          animation: true,
          templateUrl: 'app/pages/common/rolePermission/addModal.html',
          scope:$scope
        });
    };
    /**
     * saveRole method.
     * created on 01/23/2018
     */
    $scope.saveRole = function() {
      if ($cookies.get('role-id') && $cookies.get('role-id') != undefined) {
          this.roleId = $cookies.get('role-id');
      }else{
          this.roleId = '';
      }
      if (!this.roleFrm.roleName.$valid) {
        toastr.error("Please enter role name");
        angular.element('#firstname').focus();
        return;
      }
      var bodyData = {
        name: this.roleName,
        status:'Active'
      };
      apiService.loaderShow();
        $scope.saveUrl = $rootScope.baseUrl + '/role/create';
        $scope.httpMethod = 'POST';
        $scope.editedId = this.roleId;
        if (this.roleId) {
          $scope.saveUrl = $rootScope.baseUrl + '/role/update/' + this.roleId;
          $scope.httpMethod = 'PUT';
        }
        $http({
          url: $scope.saveUrl,
          method: $scope.httpMethod,
          data: $scope.dataUrlEncode(bodyData),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(response) {
          apiService.loaderHide();
          var responseData = response.data;
          if (responseData && responseData.meta.status == true) {
            toastr.success(responseData.meta.message);
            $scope.popupShow.close();
            $state.go($state.$current, null, { reload: true });
          } else {
            toastr.success(responseData.meta.message);
          }
        }, function(error) {
          apiService.loaderHide();
          var errorData=error.data;
          if (errorData && errorData.meta) {
              toastr.error(errorData.meta.message);
          }else {
            toastr.error("Something went wrong please try again.");
          }
        });
    };

  }
})();

/**
 * @author Harsha Prajapati<harsha.prajapati@brainvire.com>
 * created on 01/29/2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('settingsCtrl', settingsCtrl);

  /** @ngInject */
  function settingsCtrl($scope, $state, toastr , $cookies, $rootScope, apiService, $http) {
    /**
    * check permission to display list
    * created on 01/24/2018
    */
    if(!$scope.checkPermission('CONFIG_LIST')){
      $state.go('error-403');
    }
    $rootScope.currentState = 'settings';

    /**
    * getSettingLabel For First Caracter Capital Of String and after underscrore First Caracter is Capital.
    * Created on 01/29/2018
    */
    $scope.getSettingUCLabel =  function (str){
      if(str.includes("_")){
        var data= str.split("_");
        var res = data[0].charAt(0).toUpperCase()+ data[0].slice(1)+" "+data[1].charAt(0).toUpperCase()+ data[1].slice(1);
      }else{
        var res=str.charAt(0).toUpperCase() + str.slice(1);
      }
      return res;
    };
    $scope.getSettingLCLabel =  function (str){
      if(str.includes("_")){
        var data= str.split("_");
        var res = data[0]+" "+data[1];
      }else{
        var res=str;
      }
      return res;
    };
    /**
    * Get setting data method is use for get app setting data.
    * created on 01/29/2018
    */
    $scope.getSettingsData = function() {
         apiService.loaderShow();
         $scope.setOfSets = [];
         $http.post($rootScope.baseUrl+'/configuration/list')
        .success(function (response) {
            if(response.meta && response.meta.status == true){
                $scope.settingData=response.data;
                var half_length = Math.ceil($scope.settingData.length / 2);
                var leftArray = $scope.settingData.splice(0,half_length);
                var rightArray = $scope.settingData.splice(0,$scope.settingData.length);
                $scope.setOfSets.push(leftArray);
                $scope.setOfSets.push(rightArray);
            }
            apiService.loaderHide();
        }).error(function (response) {
          apiService.loaderHide();
          var getError=error.data;
          if (getError && getError.meta) {
              toastr.error(getError.meta.message);
          }else {
            toastr.error("Something went wrong please try again.");
          }
        });
      };

    /**
    * Update settings method is use for update app settings data.
    * created on 01/29/2018
    */
    $scope.updateSettingsData = function() {
      $scope.temp={};
      angular.forEach(this.setOfSets, function(value,key) {
        angular.forEach(value, function (setting) {
          $scope.temp[setting.option_name] = setting.option_value;
        });
      });
        apiService.loaderShow();
        var bodyData = $scope.temp;
        $http({
            url: $rootScope.baseUrl+'/configuration/update',
            method: "PUT",
            data: $scope.dataUrlEncode(bodyData),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (response) {
            var responseData=response.data;
            if (responseData.meta.status == true) {
                toastr.success(responseData.meta.message);
                $state.go($state.$current, null, { reload: true });
            }else{
                toastr.success(responseData.meta.message);
            }
            apiService.loaderHide();
        }, function (error) {
             apiService.loaderHide();
             var errorData=error.data;
             if (errorData && errorData.meta) {
                 toastr.error(errorData.meta.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
        });
    };
  }

})();

/**
 * termsCtrl controller is used to display error page.
 * @author Parth Gajjar <parth.gajjar@brainvire.com>
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.terms')
    .controller('termsCtrl', termsCtrl);

  /** @ngInject */
  function termsCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $q, $filter, $window) {
    $rootScope.currentState='terms';
    document.body.classList.add('static-page');

  
    $scope.getTerms = function () {
    	var vm = this;
    	$http.get($rootScope.baseUrl + '/content/terms-and-conditions')
                .success(function (response) {
                    var getResponse = response.data;
                    vm.id = getResponse.id;
                    vm.description = getResponse.description;
                    apiService.loaderHide();
                }).error(function (error) {
            var getError = error.data;
            apiService.loaderHide();
            if (getError && getError.meta) {
                toastr.error(getError.meta.message);
            } else {
                $state.go('terms');
                toastr.error("Something went wrong please try again.");
            }
        });
    }

  }

})();

/**
 * subAdmin controller handle all action related subAdmin.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.subAdmin')
            .controller('subAdminCtrl', subAdminCtrl);
    /** @ngInject */
    function subAdminCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $q) {
        /**
         * check permission to display list
         * created on 01/24/2018
         */
        if (!$scope.checkPermission('SUB_ADMIN_LIST')) {
            $state.go('error-403');
        }
        $rootScope.currentState = 'sub-admin';
        $rootScope.numberOfRecord = 10;
        var vm = this;
        $scope.vmAdded = this;
        
        /**
         * Search apply is use to apply filters
         * created on 01/25/2018
         */
        $scope.searchApply = function () {
            
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
        $scope.resetSearch = function () {
            vm.name = '';
            vm.email = '';
            vm.status = '';
            vm.role = '';
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
        
        /**
         * Server data method is use for load data from API.
         */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/subadmin/list',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    name: vm.name ? vm.name : '',
                    email: vm.email ? vm.email : '',
                    status: vm.status ? vm.status : '',
                    role: vm.role ? vm.role : ''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function (result) {
                apiService.loaderHide();
                var result = result.data.data.original;
                if (result) {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                } else {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                apiService.loaderHide();
                fnCallback(records);
            }, function errorCallback(response) {
                apiService.loaderHide();
            })
        }
        ;
       /**
         * Get data table method is use get list of subAdmin.
         * created on 01/17/2018
         */
        $scope.getDataTable = function () {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('srNum').withTitle('Sr.No'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('id').notVisible());
            vm.dtColumns.push(DTColumnBuilder.newColumn('first_name').withTitle('Full Name').renderWith(function (data, type, full) {
                if (!full.first_name || !full.last_name) {
                    return '---';
                } else {
                    return full.first_name + ' ' + full.last_name;
                }
            }));
            vm.dtColumns.push(DTColumnBuilder.newColumn('email').withTitle('Email'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('roles').withTitle('Role').notSortable().renderWith(function (data, type, full) {
                if (!full.roles[0]['name']) {
                    return '-';
                } else {
                    return full.roles[0]['name'];
                }
            }));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Created Date').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('updated_at').withTitle('Updated Date').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').renderWith(statusHtml).withOption('className', 'tableStatus'));
            if($scope.checkPermission('SUB_ADMIN_UPDATE') || $scope.checkPermission('SUB_ADMIN_STATUS') || $scope.checkPermission('SUB_ADMIN_CHANGE_PASSWORD') || $scope.checkPermission('SUB_ADMIN_DELETE')){
            vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('Action').renderWith(actionHtml).withOption('className', 'tableActions').withOption('orderable', false));
            }    
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withFnServerData(serverData)
                    .withOption('serverSide', true)
                    .withPaginationType('simple_numbers')
                    .withOption('deferRender', true)
                    .withOption('searching', true)
                    .withOption('autoWidth', false)
                    .withOption('sDom', 'ZlB< "row" >rtip')
                    .withOption('bLengthChange', true)
                    .withOption('iDisplayLength', ($rootScope.numberOfRecord - 1))
                    .withOption('bInfo', true)
                    .withOption('oLanguage', {
                        "sSearch": ""
                    })
                    .withOption('pageLength', 10)
                    .withOption('createdRow', compileRow)
                    .withOption('order', [1, 'desc'])
                    .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
        /**
         * add sub admin method is used for go to add sub admin page.
         * created on 01/17/2018
         */
        $scope.addSubAdmin = function () {
            $cookies.put('subadmin-id', undefined);
            $state.go('add-sub-admin');
        }
        /**
         * edit sub admin method is used for go to edit sub admin page.
         * created on 01/17/2018
         */
        $scope.editSubAdmin = function (id) {
            $cookies.put('subadmin-id', id);
            $state.go('edit-sub-admin');
        }
        /**
         * Init complete method is use for add class on DOM of datatable.
         */
        function initComplete(row, data) {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
        }
        /**
         * Compile row method is use for compile row in angular.
         */
        function compileRow(row, data) {
            $compile(angular.element(row).contents())($scope);
        }
        /**
         * Open modal popup
         */
        $scope.open = function (page, id, status) {
            if (status == 1) {
                $rootScope.status = 'Active';
            } else {
                $rootScope.status = 'Inactive';
            }
            $rootScope.statusId = id;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };
        $scope.closeModal = function () {
            angular.element('.modal').slideUp("fast");
            angular.element('.modal-backdrop').remove();
            angular.element('body').removeClass('modal-open');
        };
        /**
         * Get edited sub admin method is use for get edited sub admin data.
         * created on 01/17/2018
         */
        $scope.getEditedSubAdmin = function () {
            if (!$scope.checkPermission('SUB_ADMIN_CREATE') && $state.current.name == "add-sub-admin") {
                $state.go('error-403');
            }
            else if (!$scope.checkPermission('SUB_ADMIN_UPDATE') && $state.current.name == "edit-sub-admin") {
                $state.go('error-403');
            }
            else {
            if ($cookies.get('subadmin-id') && $cookies.get('subadmin-id') != undefined) {
                apiService.loaderShow();
                var vm = this;
                $http.get($rootScope.baseUrl + '/subadmin/show/' + $cookies.get('subadmin-id'))
                        .success(function (response) {
                            var getResponse = response.data;
                            vm.subAdminId = getResponse.id;
                            vm.firstname = getResponse.first_name;
                            vm.lastname = getResponse.last_name;
                            vm.username = getResponse.username;
                            vm.email = getResponse.email;
                            vm.role = getResponse.role_id;
                            vm.status = getResponse.status;
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var getError = error.data;
                    if (getError && getError.meta) {
                        toastr.error(getError.meta.message);
                    } else {
                        $state.go('edit-sub-admin');
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                $state.go('add-sub-admin');
            }
        }
        };
        /**
         * Change status method is use for change status of sub admin.
         * created on 01/12/2018
         */
        $scope.changeStatus = function () {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.statusId,
                    status: $rootScope.status
                };
                $http.put($rootScope.baseUrl + '/subadmin/change_status', bodyData)
                        .success(function (result) {
                            if (result.meta && result.meta.status == true) {
                                toastr.success(result.meta.message);
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.meta.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var statusError = error.data;
                    if (statusError && statusError.meta) {
                        toastr.error(statusError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };
        /**
         * Delete sub admin method is use for delete sub admin.
         * created on 01/17/2018
         */
        $scope.deleteSubAdmin = function () {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                $http.delete($rootScope.baseUrl + '/subadmin/delete/' + $rootScope.statusId)
                        .success(function (result) {
                            if (result.meta && result.meta.status == true) {
                                toastr.success(result.meta.message);
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.meta.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var deleteError = error.data;
                    if (deleteError && deleteError.meta) {
                        toastr.error(deleteError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            $scope.popupShow.close();
        };
        /**
         * get the List of role
         */
        $scope.getRoleList = function () {
            $http.get($rootScope.baseUrl + '/role/list')
                    .success(function (response) {
                        $scope.roleList = response.data;
                    }).error(function (error) {
                toastr.error("Something went wrong please try again.");
            });
        }
        /**
         * Change user password method is use for change user password.
         * created on 01/17/2018
         */
        $scope.changeUserPassword = function () {
            var vm = this;
            if (this.changePwdFrm.npassword.$error.required) {
                toastr.error("Please enter new password");
                angular.element('#newPassword').focus();
                return;
            } else if (this.changePwdFrm.npassword.$error.pattern) {
                toastr.error("Password should be 8 characters with number combination");
                angular.element('#newPassword').focus();
                return;
            } else if (this.changePwdFrm.cpassword.$error.required) {
                toastr.error("Please enter confirm password");
                angular.element('#confirmPassword').focus();
                return;
            } else if (this.changePwdFrm.cpassword.$error.pattern) {
                toastr.error("Confirm Password should match with password");
                angular.element('#confirmPassword').focus();
                return;
            }
            apiService.loaderShow();
            var bodyData = {
                user_id: $rootScope.statusId,
                new_password: this.newPassword,
                confirm_password: this.confirmPassword
            };
            $http({
                url: $rootScope.baseUrl + '/subadmin/password/change',
                method: "PUT",
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                var responseData = response.data;
                if (responseData && responseData.meta.status == true) {
                    toastr.success(responseData.meta.message);
                    $state.go($state.$current, null, {reload: true});
                } else {
                    toastr.error(responseData.meta.message);
                }
                apiService.loaderHide();
            }, function (error) {
                apiService.loaderHide();
                var passError = error.data;
                if (passError && passError.meta) {
                    toastr.error(passError.meta.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.popupShow.close();
        };

        /**
         * Save sub admin data method is used for update sub admin data.
         */
        $scope.saveSubAdminData = function () {

            if (!this.subAdminFrm.firstname.$valid) {
                toastr.error("Please enter first name");
                angular.element('#firstname').focus();
                return;
            } else if (!this.subAdminFrm.lastname.$valid) {
                toastr.error("Please enter last name");
                angular.element('#lastname').focus();
                return;
            } else if (!this.subAdminFrm.username.$valid) {
                toastr.error("Please enter username");
                angular.element('#username').focus();
                return;
            }
            else if (!this.subAdminFrm.email.$valid) {
                toastr.error("Please enter email");
                angular.element('#email').focus();
                return;
            } else if (this.subAdminFrm.role == '0') {
                toastr.error("Please select role");
                angular.element('#role').focus();
                return;
            }
            else if (this.subAdminFrm.subAdminId == "0") {
                if (this.subAdminFrm.password.$error.required) {
                    toastr.error("Please enter password");
                    angular.element('#password').focus();
                    return;
                }
                else if (this.subAdminFrm.password.$error.pattern) {
                    toastr.error("Password should be min 8 characters with number combination");
                    angular.element('#password').focus();
                    return;
                } else if (this.subAdminFrm.newPassword.$error.required) {
                    toastr.error("Please enter confirm password");
                    angular.element('#newPassword').focus();
                    return;
                } else if (this.subAdminFrm.newPassword.$error.pattern) {
                    toastr.error("Confirm Password should match with password");
                    angular.element('#newPassword').focus();
                    return;
                }
            }
            apiService.loaderShow();
            var bodyData = {
                first_name: this.firstname,
                last_name: this.lastname,
                username: this.username,
                email: this.email,
                role_id: this.role
            };
            apiService.loaderShow();
            $scope.editedId = this.subAdminId;
            if (this.subAdminId) {
                $scope.saveUrl = $rootScope.baseUrl + '/subadmin/update/' + this.subAdminId;
                $scope.httpMethod = 'PUT';
            }
            else {
                bodyData['password'] = vm.password;
                $scope.saveUrl = $rootScope.baseUrl + '/subadmin/create';
                $scope.httpMethod = 'POST';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                apiService.loaderHide();
                var responseData = response.data;
                if (responseData && responseData.meta.status == true) {
                    toastr.success(responseData.meta.message);
                    $state.go('sub-admin');
                } else {
                    $state.go('sub-admin');
                    toastr.error(responseData.meta.message);
                }
            }, function (error) {
                apiService.loaderHide();
                var errorData = error.data;
                if (errorData && errorData.meta) {
                    if (errorData.meta.message_code == 'VALIDATION_ERROR') {
                        if (errorData.errors.email) {
                            toastr.error(errorData.errors.email[0]);
                        }
                    } else {
                        toastr.error(errorData.meta.message);
                    }
                } else {
                    $state.go('sub-admin');
                    toastr.error("Something went wrong please try again.");
                }
            });
        };
        
        /**
         * Status Html method is use for prepare status badge.
         */
        function statusHtml(data) {
            var statusClass = $rootScope.getStatusClass(data);
            var statusBadge = '<span class="' + statusClass + ' font-size-14 margin-inline">' + data + '</span>';
            return statusBadge;
        }
        /**
         * Action Html method is use for prepare action html part.
         */
        function actionHtml(data, type, full) {
            var changeStatusValTo = 0;
            var editLinks = ' <a ng-if="checkPermission(\'' + 'SUB_ADMIN_UPDATE' + '\')" href="javascript:void(0);" ng-click="editSubAdmin(\'' + data + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="checkPermission(\'' + 'SUB_ADMIN_DELETE' + '\')" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/common/subAdmin/deleteModal.html' + '\',' + data + ',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg"></i> </a>';
            var changePassLinks = '  <a ng-if="checkPermission(\'' + 'SUB_ADMIN_CHANGE_PASSWORD' + '\')" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/common/subAdmin/changePasswordModal.html' + '\',' + data + ',' + changeStatusValTo + ')" title="Change Password" ><i class="fa fa-key fa-lg"></i> </a>';
            var statusLinks = ' <a ng-if="checkPermission(\'' + 'SUB_ADMIN_STATUS' + '\')" ng-click="open(\'' + 'app/pages/common/subAdmin/statusModal.html' + '\',' + data + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img class="mt-2px" src="assets/img/switch-on.png" width="24"/></a>';
            var statusClass = $rootScope.getStatusClass(full.status);
            var statusBadge = '<span class="' + statusClass + ' font-size-14 margin-inline">' + full.status + '</span>';
            if (full.status == 'Inactive') {
                changeStatusValTo = 1;
                statusLinks = ' <a ng-if="checkPermission(\'' + 'SUB_ADMIN_STATUS' + '\')" ng-click="open(\'' + 'app/pages/common/subAdmin/statusModal.html' + '\',' + data + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img class="mt-2px" src="assets/img/switch-off.png" width="24"/></a>';
            }
            return editLinks + '&nbsp;' + statusLinks + '&nbsp;' + changePassLinks + '&nbsp;' + deleteLinks
        }
    }
})();

/**
 * user controller handle all action related user.
 * @author Riya Mansuri <riya.mansuri@brainvire.com>
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.user')
            .controller('userCtrl', userCtrl);
    /** @ngInject */
    function userCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $q, $filter, $window) {

        /**
         * check permission to display list
         * created on 01/24/2018
         */
        // if (!$scope.checkPermission('USER_LIST')) {
        //     $state.go('error-403');
        // }

        $rootScope.currentState = 'user';
        $scope.minDate = new Date().toDateString();
        var vm = this;
        $scope.vmAdded = this;

        /**
         * Search apply is use to apply filters
         * created on 01/25/2018
         */
        $scope.searchApply = function () {

            $scope.vmAdded.dtInstance.DataTable.draw();
        }
        $scope.resetSearch = function () {
            vm.name = '';
            vm.email = '';
            vm.status = '';
            vm.gender = '';
            vm.phone_number = '';
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
         * Server data method is use for load data from API.
         */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/user/list',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    name: vm.name ? vm.name : '',
                    email: vm.email ? vm.email : '',
                    status: vm.status ? vm.status : '',
                    phone_number: vm.phone_number ? vm.phone_number : ''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function (result) {
                apiService.loaderHide();
                var result = result.data.data.original;
                if (result) {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                } else {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                apiService.loaderHide();
                fnCallback(records);
            }, function errorCallback(response) {
                apiService.loaderHide();
            })
        }
        ;
        /**
         * Get data table method is use get list of user.
         * created on 01/24/2018
         */
        $scope.getDataTable = function () {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('srNum').withTitle('Sr.No'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('id').notVisible());
            vm.dtColumns.push(DTColumnBuilder.newColumn('first_name').withTitle('Full name').renderWith(function (data, type, full) {
                if (!full.first_name || !full.last_name) {
                    return '---';
                } else {
                    return full.first_name + ' ' + full.last_name;
                }
            }));
            // vm.dtColumns.push(DTColumnBuilder.newColumn('username').withTitle('Username'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('email').withTitle('Email'));
            // vm.dtColumns.push(DTColumnBuilder.newColumn('gender').withTitle('Gender'));
            // vm.dtColumns.push(DTColumnBuilder.newColumn('date_of_birth').withTitle('Date of birth'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('phone_number').withTitle('Phone number'));
            vm.dtColumns.push(DTColumnBuilder.newColumn(null).withTitle('No. of test').notSortable()
            .renderWith(function(data, type, full, meta) {
                return '<button class="btn btn-warning" ng-click="viewTestUser(' + data.id + ')">' +
                    data.test_count + '</button>';
            }).withOption('className', 'tableStatus')),
            // vm.dtColumns.push(DTColumnBuilder.newColumn('test_result').withTitle('Last Test Result'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').renderWith(statusHtml).withOption('className', 'tableStatus'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Registration at').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('updated_at').withTitle('Last updated at').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            // if($scope.checkPermission('USER_UPDATE') || $scope.checkPermission('USER_STATUS') || $scope.checkPermission('USER_CHANGE_PASSWORD') || $scope.checkPermission('USER_DELETE')){
            vm.dtColumns.push(DTColumnBuilder.newColumn('id').withTitle('Action').renderWith(actionHtml).withOption('className', 'tableActions').withOption('orderable', false));
            // }
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withFnServerData(serverData)
                    .withOption('serverSide', true)
                    .withPaginationType('simple_numbers')
                    .withOption('deferRender', true)
                    .withOption('searching', true)
                    .withOption('autoWidth', false)
                    .withOption('sDom', 'ZlB< "row" >rtip')
                    .withOption('bLengthChange', true)
                    .withOption('iDisplayLength', ($rootScope.numberOfRecord - 1))
                    .withOption('bInfo', true)
                    .withOption('oLanguage', {
                        "sSearch": ""
                    })
                    .withOption('pageLength', 10)
                    .withOption('createdRow', compileRow)
                    .withOption('order', [1, 'desc'])
                    .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
        /**
         * add user method is used for go to add user page.
         * created on 01/24/2018
         */
        $scope.addUser = function () {
            $cookies.put('user-id', undefined);
            $state.go('add-user');
        }
        /**
         * edit user method is used for go to edit user page.
         * created on 01/24/2018
         */
        $scope.editUser = function (id) {
            $cookies.put('user-id', id);
            $state.go('edit-user');
        }

        $scope.viewTestUser = function (id) {
            $cookies.put('user-id', id);
            $state.go('hearing');
        }
        /**
         * Init complete method is use for add class on DOM of datatable.
         */
        function initComplete(row, data) {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
        }
        /**
         * Compile row method is use for compile row in angular.
         */
        function compileRow(row, data) {
            $compile(angular.element(row).contents())($scope);
        }
        /**
         * Open modal popup
         */
        $scope.open = function (page, id, status) {
            if (status == 1) {
                $rootScope.status = 'Active';
            } else {
                $rootScope.status = 'Inactive';
            }
            $rootScope.statusId = id;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };
        $scope.closeModal = function () {
            angular.element('.modal').slideUp("fast");
            angular.element('.modal-backdrop').remove();
            angular.element('body').removeClass('modal-open');
        };
        
        $scope.verifyUser = function () {
            var path = $window.location.hash.split('/');
            var token = path[2];

            $http.get($rootScope.baseUrl + '/verify/' + token)
                        .success(function (response) {
                            
                            var getResponse = response.meta.status_code;
                            if(getResponse == 200){
                                $scope.success_message = response.meta.message;
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                            var getError = error.data;
                            apiService.loaderHide();
                            if (getError && getError.meta) {
                                toastr.error(getError.meta.message);
                            } else {
                                // $state.go('edit-user');
                                $scope.error_message = error.meta.message;
                                // toastr.error("Something went wrong please try again.");
                            }
                        });
        };
        /**
         * Get edited user method is use for get edited user data.
         * created on 01/17/2018
         */
        $scope.getEditedUser = function () {
            // if (!$scope.checkPermission('USER_CREATE') && $state.current.name == "add-user") {
            //     $state.go('error-403');
            // }
            // else if(!$scope.checkPermission('USER_UPDATE') && $state.current.name == "edit-user") {
            //     $state.go('error-403');
            // }
            if (!$state.current.name == "add-user") {
                $state.go('error-403');
            }
            else if(!$state.current.name == "edit-user") {
                $state.go('error-403');
            }
            else {
            if ($cookies.get('user-id') && $cookies.get('user-id') != undefined) {
                apiService.loaderShow();
                var vm = this;
                $http.get($rootScope.baseUrl + '/user/show/' + $cookies.get('user-id'))
                        .success(function (response) {
                            var getResponse = response.data;
                            vm.userId = getResponse.id;
                            vm.firstname = getResponse.first_name;
                            vm.lastname = getResponse.last_name;
                            // vm.username = getResponse.username;
                            vm.email = getResponse.email;
                            // vm.dob = getResponse.date_of_birth;
                            vm.mobile = getResponse.phone_number;
                            // vm.gender = getResponse.gender;
                            apiService.loaderHide();
                        }).error(function (error) {
                    var getError = error.data;
                    apiService.loaderHide();
                    if (getError && getError.meta) {
                        toastr.error(getError.meta.message);
                    } else {
                        $state.go('edit-user');
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                $state.go('add-user');
            }
        }
        };
        /**
         * Change status method is use for change status of user.
         * created on 01/12/2018
         */
        $scope.changeStatus = function () {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.statusId,
                    status: $rootScope.status
                };
                $http.put($rootScope.baseUrl + '/user/change_status', bodyData)
                        .success(function (result) {
                            if (result.meta.status == true) {
                                toastr.success(result.meta.message);
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.meta.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var statusError = error.data;
                    if (statusError && statusError.meta) {
                        toastr.error(statusError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };
        /**
         * Delete user method is use for delete user.
         * created on 01/17/2018
         */
        $scope.deleteUser = function () {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                $http.delete($rootScope.baseUrl + '/user/delete/' + $rootScope.statusId)
                        .success(function (result) {
                            if (result.meta.status == true) {
                                toastr.success(result.meta.message);
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.meta.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    var deleteError = error.data;
                    if (deleteError && deleteError.meta) {
                        toastr.error(deleteError.meta.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            $scope.popupShow.close();
        };

        /**
         * Change user password method is use for change user password.
         * created on 01/17/2018
         */
        $scope.changeUserPassword = function () {
            var vm = this;
            if (this.changePwdFrm.npassword.$error.required) {
                toastr.error("Please enter new password");
                angular.element('#newPassword').focus();
                return;
            } else if (this.changePwdFrm.npassword.$error.pattern) {
                toastr.error("Password should be 8 characters with number combination");
                angular.element('#newPassword').focus();
                return;
            } else if (this.changePwdFrm.cpassword.$error.required) {
                toastr.error("Please enter confirm password");
                angular.element('#confirmPassword').focus();
                return;
            } else if (this.changePwdFrm.cpassword.$error.pattern) {
                toastr.error("Confirm Password should match with password");
                angular.element('#confirmPassword').focus();
                return;
            }
            apiService.loaderShow();
            var bodyData = {
                user_id: $rootScope.statusId,
                new_password: this.newPassword,
                confirm_password: this.confirmPassword
            };
            $http({
                url: $rootScope.baseUrl + '/user/password/change',
                method: "PUT",
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                var responseData = response.data;
                if (responseData.meta.status == true) {
                    toastr.success(responseData.meta.message);
                    $state.go($state.$current, null, {reload: true});
                } else {
                    toastr.error(responseData.meta.message);
                }
                apiService.loaderHide();
            }, function (error) {
                var passError = error.data;
                if (passError && passError.meta) {
                    toastr.error(passError.meta.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                apiService.loaderHide();
            });
            $scope.popupShow.close();
        };
        /**
         * Save user data method is used for update user data.
         */

        $scope.saveUserData = function () {
            if (!this.userFrm.firstname.$valid) {
                toastr.error("Please enter first name");
                angular.element('#firstname').focus();
                return;
            } else if (!this.userFrm.lastname.$valid) {
                toastr.error("Please enter last name");
                angular.element('#lastname').focus();
                return;
            }/* else if (!this.userFrm.username.$valid) {
                toastr.error("Please enter username");
                angular.element('#username').focus();
                return;
            }*/
            else if (!this.userFrm.email.$valid) {
                toastr.error("Please enter email");
                angular.element('#email').focus();
                return;
            }
            /*else if (!this.userFrm.dob.$valid) {
                toastr.error("Please select date of birth");
                angular.element('#dob').focus();
                return;
            }
            else if (!this.userFrm.gender.$valid) {
                toastr.error("Please select gender");
                angular.element('#gender').focus();
                return;
            }*/
            else if (!this.userFrm.mobile.$valid) {
                toastr.error("Please enter phone number");
                angular.element('#mobile').focus();
                return;
            }
            else if (this.userFrm.userId == "0") {
                if (this.userFrm.password.$error.required) {
                    toastr.error("Please enter password");
                    angular.element('#password').focus();
                    return;
                }
                else if (this.userFrm.password.$error.pattern) {
                    toastr.error("Password should be min 8 characters with number combination");
                    angular.element('#password').focus();
                    return;
                } else if (this.userFrm.newPassword.$error.required) {
                    toastr.error("Please enter confirm password");
                    angular.element('#newPassword').focus();
                    return;
                } else if (this.userFrm.newPassword.$error.pattern) {
                    toastr.error("Confirm Password should match with password");
                    angular.element('#newPassword').focus();
                    return;
                }
            }
            var bodyData = {
                first_name: this.firstname,
                last_name: this.lastname,
                // username: this.username,
                // date_of_birth: this.dob,
                // gender: this.gender,
                phone_number: this.mobile
            };
            apiService.loaderShow();
            $scope.editedId = this.userId;
            if (this.userId) {
                $scope.saveUrl = $rootScope.baseUrl + '/user/update/' + this.userId;
                $scope.httpMethod = 'PUT';
            } else
            {
                bodyData['email'] = this.email;
                bodyData['password'] = vm.password;
                $scope.saveUrl = $rootScope.baseUrl + '/user/create';
                $scope.httpMethod = 'POST';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                apiService.loaderHide();
                var responseData = response.data;
                if (responseData.meta.status == true) {
                    toastr.success(responseData.meta.message);
                    $state.go('user');
                } else {
                    $state.go('user');
                    toastr.error(responseData.meta.message);
                }
            }, function (error) {
                var errorData = error.data;
                apiService.loaderHide();
                if (errorData && errorData.meta) {
                    if (errorData.meta.message_code == 'VALIDATION_ERROR') {
                        if (errorData.errors.email) {
                            toastr.error(errorData.errors.email[0]);
                        }
                    } else {
                        toastr.error(errorData.meta.message);
                    }
                } else {
                    $state.go('user');
                    toastr.error("Something went wrong please try again.");
                }
            });
        };

        /**
         * Status Html method is use for prepare status badge.
         */
        function statusHtml(data) {
            var statusClass = $rootScope.getStatusClass(data);
            var statusBadge = '<span class="' + statusClass + ' font-size-14 margin-inline">' + data + '</span>';
            return statusBadge;
        }
        /**
         * Action Html method is use for prepare action html part.
         */
        function actionHtml(data, type, full) {
            var changeStatusValTo = 0;
            var editLinks = ' <a  href="javascript:void(0);" ng-click="editUser(\'' + data + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a href="javascript:void(0);" ng-click="open(\'' + 'app/pages/common/user/deleteModal.html' + '\',' + data + ',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg"></i> </a>';
            var changePassLinks = '  <a href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/common/user/changePasswordModal.html' + '\',' + data + ',' + changeStatusValTo + ')" title="Change Password" ><i class="fa fa-key fa-lg"></i> </a>';
            var statusLinks = ' <a ng-click="open(\'' + 'app/pages/common/user/statusModal.html' + '\',' + data + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img class="mt-2px" src="assets/img/switch-on.png" width="24"/></a>';
            var statusClass = $rootScope.getStatusClass(full.status);
            var statusBadge = '<span class="' + statusClass + ' font-size-14 margin-inline">' + full.status + '</span>';
            if (full.status == 'Inactive') {
                changeStatusValTo = 1;
                statusLinks = ' <a ng-click="open(\'' + 'app/pages/common/user/statusModal.html' + '\',' + data + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img class="mt-2px" src="assets/img/switch-off.png" width="24"/></a>';
            }
            return editLinks + '&nbsp;' + statusLinks + '&nbsp;' + changePassLinks + '&nbsp;' + deleteLinks
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  menuName: meta.menuName,
                  stateRef: s.name,
                  permissionKey: s.permissionKey
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil,$rootScope, apiService, $http) {
    $rootScope.currentState='dashboard';
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts1 = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];
    // console.log($scope.charts1);

    apiService.loaderShow();
    $http({
        method: 'POST',
        url: $rootScope.baseUrl + '/home/list',
        /*data: {
            start: aoData[3].value,
            length: aoData[4].value,
            draw: aoData[0].value,
            order: aoData[2].value,
            search: aoData[5].value,
            columns: aoData[1].value,
            clinic_name: vm.clinic_name ? vm.clinic_name : '',
            status: vm.status ? vm.status : '',
        },*/
        headers: {
            'Content-type': 'application/json'
        }
    }).then(function (result) {
        apiService.loaderHide();
        var result = result.data;
        if (result) {
            $scope.charts = [{
                color: pieColor,
                description: 'Users',
                stats: result.data.users,
                icon: 'person',
              }, {
                color: pieColor,
                description: 'Clinics',
                stats: result.data.clinics,
                icon: 'refresh',
              }, {
                color: pieColor,
                description: 'Hearing Test',
                stats: result.data.test,
                icon: 'face',
              }
            ];


            $scope.labels =result.data.labels;
            $scope.data = [
              result.data.data
            ];
            $scope.series = result.data.series;
        } else {
            var records = {
                'draw': 1,
                'iTotalDisplayRecords': 0,
                'iTotalRecords': 0,
                'aaData': []
            };
        }
        apiService.loaderHide();
    }, function errorCallback(response) {
        apiService.loaderHide();
    })

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);


    
    /*$scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56]
    ];
    $scope.series = ['Product A'];*/
    
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/common/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/common/clinic/addClinic.html','<div ba-panel="" ba-panel-class="with-scroll" ;="" status="Active" "=""><div class="panel-content" ng-init="getEditedClinic()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="clinicFrm" ng-submit="submitted = true" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="clinic_name" class="col-sm-3 text-right">Clinic Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="clinic_name" type="text" placeholder="Clinic Name" ng-model="clinic_name" limit-to="20" ng-maxlength="20" name="clinic_name" required="" class="form-control" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="submitted && clinicFrm.clinic_name.$error.required">Please enter clinic name</span> <span class="error" ng-show="clinicFrm.clinic_name.$error.pattern">Please enter valid clinic name</span> <span class="error" ng-show="clinicFrm.clinic_name.$error.maxlength && clinicFrm.clinic_name.$touched">Clinic Name should not be greater than 20 characters</span></div></div></div></div><div class="row"><button type="submit" ng-click="clinicFrm.$valid && saveClinicData()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="clinic" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="clinicId" name="clinicId"></div></form></div></div>');
$templateCache.put('app/pages/common/clinic/clinic.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-9"><div class="col-md-3"><input id="clinic_name" name="clinic_name" class="form-control filter-fullname" placeholder="Clinic Name" type="text" ng-model="vm.clinic_name"></div><div class="col-md-3"><select id="status" class="form-control" ng-model="vm.status" name="status"><option value="">Select status</option><option value="Active">Active</option><option value="Inactive">Inactive</option></select></div></div><div class="row"><div class="col-md-1 pull-right"><button type="button" ng-click="resetSearch()" class="pull-right btn btn-warning btn-with-icon ng-scope"><i class="ion-android-warning"></i>Reset</button></div><div class="col-md-1 pull-right"><button type="button" ng-click="searchApply()" class="pull-right btn btn-primary btn-with-icon ng-scope"><i class="ion-android-checkmark-circle"></i>Apply</button></div></div></div><div class="row"><div class="col-md-12" style="top: 20px"><button ng-click="addClinic()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/common/clinic/deleteModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="deleteClinic()">YES</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">NO</button></div></div>');
$templateCache.put('app/pages/common/clinic/statusModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="changeStatus()">Yes</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">No</button></div></div>');
$templateCache.put('app/pages/common/cms/addCMS.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="cmsStatus=\'Active\'"><div class="panel-content summerNote" ng-init="getEditedCms()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="cmsFrm" ng-submit="submitted = true" novalidate=""><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="inputCMSTitle" class="col-md-2 text-right">CMS Title <span class="asterisk_input"></span></label><div class="col-md-10"><input id="inputCMSTitle" name="inputCMSTitle" type="text" ng-model="cmsTitle" required="" class="form-control" placeholder="CMS Title"> <span class="error" ng-show="submitted && cmsFrm.inputCMSTitle.$error.required">Please enter cms title</span></div></div></div><div class="col-md-12 mb-10px"><div class="form-group row clearfix"><label class="col-md-2 text-right">CMS Description <span class="asterisk_input"></span></label><div class="col-md-10"><summernote height="300" ng-model="cmsDescription"></summernote></div></div></div><div class="col-md-12"><div class="form-group row clearfix"><label for="metaTitle" class="col-md-2 text-right">Meta Title <span class="asterisk_input"></span></label><div class="col-md-10"><input id="metaTitle" name="metaTitle" type="text" ng-model="metaTitle" required="" class="form-control" placeholder="Meta Title"> <span class="error" ng-show="submitted && cmsFrm.metaTitle.$error.required">Please enter cms meta title</span></div></div></div><div class="col-md-12"><div class="form-group row clearfix"><label for="metaDescription" class="col-md-2 text-right">Meta Description <span class="asterisk_input"></span></label><div class="col-md-10"><input id="metaDescription" name="metaDescription" type="text" ng-model="metaDescription" required="" class="form-control" placeholder="Meta Description"> <span class="error" ng-show="submitted && cmsFrm.metaDescription.$error.required">Please enter cms meta description</span></div></div></div><div class="col-md-12"><div class="form-group row clearfix"><label class="col-md-2 control-label">Status <span class="asterisk_input"></span></label><div class="col-md-10"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="cmsStatus" type="radio" name="cmsStatus" id="status" value="Active"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="cmsStatus" type="radio" name="cmsStatus" id="inlineRadio2" value="Inactive"> <span>Inactive</span></label> <span class="error" ng-show="submitted && cmsFrm.cmsStatus.$error.required">Please select cms status</span></div></div></div><button type="submit" ng-click="cmsFrm.$valid && saveCMS()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="cms-management" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="cmsId"></div></form></div></div>');
$templateCache.put('app/pages/common/cms/cms.html','<div class="widgets" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/common/cms/statusModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">NO</button></div></div>');
$templateCache.put('app/pages/common/contactClinic/contactClinic.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-9"><div class="col-md-3"><input id="fullname" name="fullname" class="form-control filter-fullname" placeholder="User Name" type="text" ng-model="vm.fullname"></div><div class="col-md-3"><input id="phone_number" name="phone_number" class="form-control filter-fullname" placeholder="Phone Number" type="text" ng-model="vm.phone_number"></div><div class="col-md-3"><input id="email" name="email" class="form-control filter-fullname" placeholder="Email" type="text" ng-model="vm.email"></div></div><div class="row"><div class="col-md-1 pull-right"><button type="button" ng-click="resetSearch()" class="pull-right btn btn-warning btn-with-icon ng-scope"><i class="ion-android-warning"></i>Reset</button></div><div class="col-md-1 pull-right"><button type="button" ng-click="searchApply()" class="pull-right btn btn-primary btn-with-icon ng-scope"><i class="ion-android-checkmark-circle"></i>Apply</button></div></div></div><div class="row"><div class="col-md-12"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/common/contactClinic/deleteModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="deleteClinic()">YES</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">NO</button></div></div>');
$templateCache.put('app/pages/common/contactClinic/statusModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="changeStatus()">Yes</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">No</button></div></div>');
$templateCache.put('app/pages/common/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart>');
$templateCache.put('app/pages/common/emailTemplate/addEmailTemplate.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content summerNote" ng-init="getEditedEmailTemplate()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="emailTemplateFrm" ng-submit="submitted = true" novalidate=""><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="emailTemplateSubject" class="col-md-2 text-right">Subject <span class="asterisk_input"></span></label><div class="col-md-10"><input id="emailTemplateSubject" name="emailTemplateSubject" type="text" ng-model="emailTemplateSubject" required="" class="form-control" placeholder="Email Template Subject"> <span class="error" ng-show="submitted && emailTemplateFrm.emailTemplateSubject.$error.required">Please enter subject</span></div></div></div><div class="col-md-12 mb-10px"><div class="form-group row clearfix"><label class="col-md-2 text-right">Content <span class="asterisk_input"></span></label><div class="col-md-10"><summernote height="300" ng-model="emailTemplateContent"></summernote></div></div></div></div><button type="submit" ng-click="emailTemplateFrm.$valid && saveEmailTemplate()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="email-template" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="emailTemplateId"></form></div></div>');
$templateCache.put('app/pages/common/emailTemplate/emailTemplate.html','<div class="widgets" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"></div></div><div class="row"><div class="col-md-12"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/common/error403/error403.html','<div class="page-not-found-modal"><h1>Error 403</h1><p>You are not authorized to view this page. <a href="" ui-sref="dashboard">Go to Dashboard</a></p></div>');
$templateCache.put('app/pages/common/faq/addFAQ.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="faqStatus=\'Active\'"><div class="panel-content" ng-init="getEditedFAQ()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="faqFrm" ng-submit="submitted = true" novalidate=""><div class="row"><div class="col-md-12" ng-init="getFAQTopic()"><div class="form-group row clearfix"><label for="faqTopic" class="col-md-2 text-right">FAQ Topic <span class="asterisk_input"></span></label><div class="col-md-10"><select id="faqTopic" class="form-control faqData" ng-model="faqTopic"><option ng-repeat="formOfTrans in standardSelectItems" value="{{formOfTrans.value}}">{{formOfTrans.label}}</option></select><span class="error" ng-show="submitted && faqTopic==\'0\'">Please select faq topic</span></div></div></div><div class="col-md-12"><div class="form-group row clearfix"><label for="faqQuestion" class="col-md-2 text-right">Question <span class="asterisk_input"></span></label><div class="col-md-10"><input id="faqQuestion" name="faqQuestion" type="text" ng-model="faqQuestion" required="" class="form-control" placeholder="Question"> <span class="error" ng-show="submitted && faqFrm.faqQuestion.$error.required">Please enter question</span></div></div></div><div class="col-md-12 mb-10px"><div class="form-group row clearfix"><label class="col-md-2 text-right">Answer <span class="asterisk_input"></span></label><div class="col-md-10"><textarea placeholder="Answer" name="faqAnswer" ng-model="faqAnswer" class="form-control" id="faqAnswer" required=""></textarea> <span class="error" ng-show="submitted && faqFrm.faqAnswer.$error.required">Please enter answer</span></div></div></div><div class="col-md-12"><div class="form-group row clearfix"><label class="col-md-2 control-label">Status <span class="asterisk_input"></span></label><div class="col-md-10"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="faqStatus" type="radio" name="faqStatus" id="status" value="Active"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="faqStatus" type="radio" name="faqStatus" id="inlineRadio2" value="Inactive"> <span>Inactive</span></label> <span class="error" ng-show="submitted && faqFrm.faqStatus.$error.required">Please select faq status</span></div></div></div><button type="submit" ng-click="faqFrm.$valid && saveFAQ()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="faq-management" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="faqId"></div></form></div></div>');
$templateCache.put('app/pages/common/faq/deleteModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="deleteFAQ()">YES</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">NO</button></div></div>');
$templateCache.put('app/pages/common/faq/faq.html','<div class="widgets" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="checkPermission(\'FAQ_CREATE\')" ng-click="addFAQ()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/common/faq/statusModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">NO</button></div></div>');
$templateCache.put('app/pages/common/hearingTest/deleteModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="deleteClinic()">YES</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">NO</button></div></div>');
$templateCache.put('app/pages/common/hearingTest/hearing.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-9"><div class="col-md-3"><input id="name" name="name" class="form-control filter-fullname" placeholder="Name" type="text" ng-model="vm.name"></div><div class="col-md-3"><input id="fullname" name="fullname" class="form-control filter-fullname" placeholder="User Name" type="text" ng-model="vm.fullname"> <input id="user_id" name="user_id" class="form-control filter-fullname" placeholder="User Name" type="hidden" ng-model="vm.user_id"></div><div class="col-md-3"><input id="uuid" name="uuid" class="form-control filter-fullname" placeholder="UUID" type="text" ng-model="vm.uuid"></div></div><div class="row"><div class="col-md-1 pull-right"><button type="button" ng-click="resetSearch()" class="pull-right btn btn-warning btn-with-icon ng-scope"><i class="ion-android-warning"></i>Reset</button></div><div class="col-md-1 pull-right"><button type="button" ng-click="searchApply()" class="pull-right btn btn-primary btn-with-icon ng-scope"><i class="ion-android-checkmark-circle"></i>Apply</button></div></div></div><div class="row"></div><div class="row"><div class="col-md-12"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/common/hearingTest/statusModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="changeStatus()">Yes</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">No</button></div></div>');
$templateCache.put('app/pages/common/hearingTest/viewHearing.html','<div ba-panel="" ba-panel-class="with-scroll" ;="" status="Active" "=""><div class="panel-content" ng-init="getViewedHearing()"><form class="form-horizontal" name="hearingFrm" ng-submit="submitted = true" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="name" class="col-sm-3">Name</label> <label class="col-sm-9">{{ name }}</label></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="frequency" class="col-sm-3">Frequency</label> <label class="col-sm-9">{{ frequency }}</label></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="decibel" class="col-sm-3">Decibel</label> <label class="col-sm-9">{{ decibel }}</label></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="result_range" class="col-sm-3">Test Result</label> <label class="col-sm-9">{{ result_range }}</label></div></div><div class="col-md-12"><div class="form-group row clearfix"><label for="description" class="col-sm-1">Description</label> <label class="col-sm-11">{{ description }}</label></div></div></div><div class="row"><div ba-panel="" ba-panel-title="Hearing Test" ba-panel-class="xmedium-panel with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div></form></div></div>');
$templateCache.put('app/pages/common/login/forgotPassword.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Forgot Password</span></div><form class="form-horizontal" ng-submit="submitted = true" name="forgotPasswordFrm" novalidate=""><div class="modal-body"><p>Enter your e-mail address below to reset your password.</p><div class="form-group"><div class="col-sm-12"><input type="text" name="emailAddForgotpass" required="" ng-model="emailAddForgotpass" class="form-control" id="inputEmailFrgt" placeholder="Enter Email" ng-pattern="/^[a-z]+[a-zA-Z0-9._+]+@[a-zA-Z0-9]+\\.[a-z.]{2,5}$/"> <span class="error" ng-show="submitted && forgotPasswordFrm.emailAddForgotpass.$error.required">Please enter email</span> <span class="error" ng-show="forgotPasswordFrm.emailAddForgotpass.$error.pattern">Please enter valid email</span></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-click="forgotPasswordFrm.$valid && forgotPassword()">Submit</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div></form></div>');
$templateCache.put('app/pages/common/login/login.html','<main class="auth-main"><div class="auth-block"><h1>Hearing Tool Log In</h1><form class="form-horizontal" name="loginFrm" ng-submit="submitted = true" novalidate=""><div class="form-group" ng-class="{\'has-error\': (loginFrm.emailAdd.$error.required || loginFrm.emailAdd.$error.pattern) && loginFrm.emailAdd.$touched}"><label for="inputEmail3" class="control-label">Email <span class="asterisk_input"></span></label><div class="col-sm-10 col-xs-12 pull-right"><input type="text" name="emailAdd" required="" ng-model="emailAdd" class="form-control" id="inputEmail" placeholder="Email Address" ng-pattern="/^[a-z]+[a-zA-Z0-9._+]+@[a-zA-Z0-9]+\\.[a-z.]{2,5}$/"> <span class="error" ng-show="submitted && loginFrm.emailAdd.$error.required">Please enter email</span> <span class="error" ng-show="loginFrm.emailAdd.$error.pattern">Please enter valid email</span></div></div><div class="form-group" ng-class="{\'has-error\': loginFrm.password.$touched && loginFrm.password.$error.required}"><label for="inputPassword" class="control-label">Password <span class="asterisk_input"></span></label><div class="col-sm-10 col-xs-12 pull-right"><input type="password" required="" name="password" ng-model="password" class="form-control" id="inputPassword" placeholder="Password"> <span class="error" ng-show="submitted && loginFrm.password.$error.required">Please enter password</span></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10 col-xs-12"><div class="pull-left clearfix"><div class="checkbox"><label class="custom-checkbox checkbox-color"><input ng-model="rememberme" type="checkbox" id="checkboxSuccess"> <span class="white-text">Remember Me</span></label></div></div><a href="" class="forgot-pass" ng-click="goToForgotPassword()">Forgot Password?</a></div><div class="col-sm-offset-2 col-sm-10 col-xs-12"><button type="submit" ng-click="loginFrm.$valid && login()" class="btn btn-primary btn-login">Log In</button></div></div></form></div></main>');
$templateCache.put('app/pages/common/privacyPolicy/privacy-policy.html','<main class="auth-main"><div class="cms-block" ng-init="getPrivacy()"><h1>Privacy Policy</h1><div class="form-group"><div class="col-sm-12 col-xs-12 pull-right"><div class="form-group" ng-bind-html="description"></div></div></div></div></main>');
$templateCache.put('app/pages/common/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><h3 class="with-line">Profile Information</h3><div ng-init="getUserProfile()"><form class="form-horizontal" name="profileFrm" ng-submit="submitted = true" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">First Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="firstname" type="text" ng-model="firstname" limit-to="20" ng-maxlength="20" name="firstname" required="" class="form-control" placeholder="First Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="submitted && profileFrm.firstname.$error.required">Please enter first name</span> <span class="error" ng-show="profileFrm.firstname.$error.pattern">Please enter valid first name</span> <span class="error" ng-show="profileFrm.firstname.$error.maxlength && profileFrm.firstname.$touched">First Name should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Last Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="lastname" type="text" ng-model="lastname" limit-to="20" ng-maxlength="20" name="lastname" required="" class="form-control" placeholder="Last Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="submitted && profileFrm.lastname.$error.required">Please enter last name</span> <span class="error" ng-show="profileFrm.lastname.$error.pattern">Please enter valid last name</span> <span class="error" ng-show="profileFrm.lastname.$error.maxlength && profileFrm.lastname.$touched">Last Name should not be greater than 20 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-4 control-label">Email</label><div class="col-sm-8"><input type="email" ng-model="email" class="form-control" id="inputEmail3" placeholder="johndoe@domain.com" disabled="disabled"></div></div></div></div><div class="row"><div class="col-md-6"><button type="submit" ng-click="profileFrm.$valid && updateUserProfile()" class="btn btn-primary btn-with-icon save-profile mr-8"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></div></form></div><h3 class="with-line">Change Password</h3><form class="form-horizontal" name="changePwdFrm" ng-submit="submittedPass = true" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="opassword" class="col-sm-4 text-right">Old Password <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="opassword" type="password" ng-model="oldPassword" name="opassword" required="" class="form-control" placeholder="Old Password" ng-pattern="/[a-zA-Z\\d!~@#$%^&*()]{6}/"> <span class="error" ng-show="submittedPass && changePwdFrm.opassword.$error.required">Please enter old password</span> <span class="error" ng-show="changePwdFrm.opassword.$error.pattern">Password should be 6 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="npassword" class="col-sm-4 text-right">New Password <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="npassword" type="password" ng-model="newPassword" name="npassword" required="" class="form-control" placeholder="New Password" ng-pattern="/[a-zA-Z\\d!~@#$%^&*()]{6}/"> <span class="error" ng-show="submittedPass && changePwdFrm.npassword.$error.required">Please enter new password</span> <span class="error" ng-show="changePwdFrm.npassword.$error.pattern">Password should be 6 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="cpassword" class="col-sm-4 text-right">Confirm Password <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="password" required="" ng-model="confirmPassword" name="cpassword" class="form-control" id="cpassword" placeholder="Confirm Password" ng-pattern="newPassword"> <span class="error" ng-show="submittedPass && changePwdFrm.cpassword.$error.required">Please enter confirm password</span> <span class="error" ng-show="changePwdFrm.cpassword.$error.pattern">Confirm Password should match with password</span></div></div></div></div><div class="row"><div class="col-md-12"><button type="submit" ng-click="changePwdFrm.$valid && changeUserPassword()" class="btn btn-primary btn-with-icon save-profile mr-8"><i class="ion-android-checkmark-circle"></i>Change Password</button></div></div></form></div></div>');
$templateCache.put('app/pages/common/resetPassword/resetPassword.html','<main class="auth-main"><div class="auth-block" ng-init="validateResetPass()"><h1>Reset Password</h1><form class="form-horizontal" name="resetPassFrm" ng-submit="submitted = true" novalidate=""><div class="form-group"><label for="inputPassword3" class="control-label">New Password <span class="asterisk_input"></span></label><div class="col-sm-9 col-xs-12 pull-right"><input type="password" required="" name="newPassword" ng-model="newPassword" class="form-control" id="newPassword" placeholder="New Password" ng-pattern="/[a-zA-Z\\d!~@#$%^&*()]{6}/"> <span class="error" ng-show="submitted && resetPassFrm.newPassword.$error.required">Please enter new password</span> <span class="error" ng-show="resetPassFrm.newPassword.$error.pattern">Password should be 6 characters</span></div></div><div class="form-group"><label for="inputPassword3" class="control-label">Confirm Password <span class="asterisk_input"></span></label><div class="col-sm-9 col-xs-12 pull-right"><input type="password" required="" name="confirmPassword" ng-model="confirmPassword" class="form-control" id="confirmPassword" placeholder="Confirm Password" ng-pattern="newPassword"> <span class="error" ng-show="submitted && resetPassFrm.confirmPassword.$error.required">Please enter confirm password</span> <span class="error" ng-show="resetPassFrm.confirmPassword.$error.pattern">Confirm Password should match with password</span></div></div><div class="form-group"><div class="col-sm-offset-3 col-sm-9 col-xs-12"><button type="submit" ng-click="resetPassFrm.$valid && resetPass()" class="btn btn-primary btn-auth mr-8px">Save</button> <a ui-sref="login" class="btn btn-warning white-text">Cancel</a></div></div></form></div></main>');
$templateCache.put('app/pages/common/rolePermission/addModal.html','<div class="modal-content"><form class="form-horizontal" name="roleFrm" ng-submit="submitted = true" novalidate=""><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span ng-bind="pgmTitle"></span></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="roleName" class="col-md-2 text-right">Role <span class="asterisk_input"></span></label><div class="col-md-10"><input id="roleName" name="roleName" type="text" ng-model="roleName" required="" class="form-control" placeholder="Role Name"> <span class="error" ng-show="submitted && roleFrm.roleName.$error.required">Please enter role name</span></div></div></div><input type="hidden" ng-model="roleId"></div></div><div class="modal-footer"><button type="submit" ng-click="roleFrm.$valid && saveRole()" class="btn btn-primary btn-with-icon">Save</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">Cancel</button></div></form></div>');
$templateCache.put('app/pages/common/rolePermission/rolePermission.html','<div class="row" ng-init="currRoleId=\'1\'"><div class="col-md-6 col-sm-12" ng-init="getPermissionList(1)"><div class="panel panel-default bootstrap-panel animated zoomIn"><div class="panel-heading"><span class="pull-left mr-8px panel-title">Roles</span><div class="pull-left mt-8px"><select class="form-control" ng-model="currRoleId" ng-change="getPermissionList(currRoleId)"><option value="0">Select Role</option><option ng-repeat="adRm in adminRoles" ng-if="adRm.status==\'Active\'" value="{{adRm.id}}">{{adRm.name}}</option></select></div><div class="pull-right mt-8px"><button type="submit" ng-click="savePermission()" class="btn btn-primary btn-with-icon"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="panel-body tree-panel"><div class="row"><div class="col-sm-8"><div id="jsTree" js-tree="basicConfig" ng-model="permissionData" should-apply="applyModelChanges()" tree="treeInstance" tree-events="ready:readyCB"></div></div></div></div></div></div><div class="col-md-6 col-sm-12"><div ba-panel="" ba-panel-title="Listing" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="checkPermission(\'ROLE_CREATE\')" ng-click="addRole()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div ng-controller="getDataRoleTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/common/rolePermission/statusModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">NO</button></div></div>');
$templateCache.put('app/pages/common/settings/settings.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><h3 class="with-line">General Settings</h3><div ng-init="getSettingsData()"><form class="form-horizontal" name="settingsFrm" ng-submit="submitted = true" novalidate=""><div class="row"><div class="col-md-6" ng-repeat="set in setOfSets"><div ng-repeat="setting in set"><div class="form-group row clearfix" ng-init="label=getSettingUCLabel(setting.option_name);name=setting.option_name"><label for="inputFirstName" class="col-sm-4 control-label">{{label}} <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="setting-{{$index}}" type="text" ng-model="setting.option_value" name="{{name}}" required="" class="form-control" placeholder="{{label}}"> <span class="error" ng-show="submitted && settingsFrm.{{name}}.$error.required">Please enter {{getSettingLCLabel(setting.option_name)}}</span></div></div></div></div></div><div class="row"><div class="col-md-6"><button ng-if="checkPermission(\'CONFIG_UPDATE\')" type="submit" ng-click="settingsFrm.$valid && updateSettingsData()" class="btn btn-primary btn-with-icon save-profile mr-8"><i class="ion-android-checkmark-circle"></i>Update</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/common/staticPages/terms.html','<main class="auth-main"><div class="cms-block" ng-init="getTerms()"><h1>Terms & Conditions</h1><div class="form-group"><div class="col-sm-12 col-xs-12 pull-right"><div class="form-group" ng-bind-html="description"></div></div></div></div></main>');
$templateCache.put('app/pages/common/subAdmin/addSubAdmin.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="role = \'0\'; status = \'Active\'"><div class="panel-content" ng-init="getEditedSubAdmin()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="subAdminFrm" ng-submit="submitted = true" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="firstname" class="col-sm-3 text-right">First Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="firstname" type="text" placeholder="First Name" ng-model="firstname" limit-to="20" ng-maxlength="20" name="firstname" required="" class="form-control" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="submitted && subAdminFrm.firstname.$error.required">Please enter first name</span> <span class="error" ng-show="subAdminFrm.firstname.$error.pattern">Please enter valid first name</span> <span class="error" ng-show="subAdminFrm.firstname.$error.maxlength && subAdminFrm.firstname.$touched">First Name should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="lastname" class="col-sm-3 text-right">Last Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="lastname" type="text" placeholder="Last Name" ng-model="lastname" limit-to="20" ng-maxlength="20" name="lastname" required="" class="form-control" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="submitted && subAdminFrm.lastname.$error.required">Please enter last name</span> <span class="error" ng-show="subAdminFrm.lastname.$error.pattern">Please enter valid last name</span> <span class="error" ng-show="subAdminFrm.lastname.$error.maxlength && subAdminFrm.lastname.$touched">Last Name should not be greater than 20 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="username" class="col-sm-3 text-right">Username <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="username" type="text" placeholder="Username" ng-model="username" limit-to="20" ng-maxlength="20" name="username" required="" class="form-control" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="submitted && subAdminFrm.username.$error.required">Please enter username</span> <span class="error" ng-show="subAdminFrm.username.$error.pattern">Please enter valid username</span> <span class="error" ng-show="subAdminFrm.username.$error.maxlength && subAdminFrm.username.$touched">Username should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="email" class="col-sm-3 text-right">Email Address <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="email" type="email" placeholder="Email Address" ng-disabled="subAdminId" ng-model="email" name="email" required="" class="form-control" ng-pattern="/^[a-z]+[a-zA-Z0-9._+]+@[a-zA-Z0-9]+\\.[a-z.]{2,5}$/"> <span class="error" ng-show="submitted && subAdminFrm.email.$error.required">Please enter email</span> <span class="error" ng-show="subAdminFrm.email.$error.pattern">Please enter valid email</span></div></div></div></div><div class="row" ng-if="!subAdminId?true:false"><div class="col-md-6"><div class="form-group row clearfix"><label for="password" class="col-sm-3 control-label">Password <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="password" type="password" ng-model="subAdmin.password" name="password" required="" class="form-control" placeholder="Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]{8,}$/"> <span class="error" ng-show="submitted && subAdminFrm.password.$error.required">Please enter password</span> <span class="error" ng-show="subAdminFrm.password.$error.pattern">Password should be min 8 characters with number combination</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label" style="padding: 0px">Confirm Password <span class="asterisk_input"></span></label><div class="col-sm-9"><input type="password" required="" ng-model="subAdmin.newPassword" name="newPassword" class="form-control" id="newPassword" placeholder="Confirm Password" ng-pattern="subAdmin.password"> <span class="error" ng-show="submitted && subAdminFrm.newPassword.$error.required">Please enter confirm password</span> <span class="error" ng-show="subAdminFrm.newPassword.$error.pattern">Confirm Password should match with password</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-init="getRoleList()"><label for="role" class="col-sm-3 text-right">Role <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="role" class="form-control" ng-model="role" name="role" required=""><option value="0">Select Role</option><option ng-repeat="usrRole in roleList" value="{{usrRole.id}}" ng-selected="usrRole.id == role">{{usrRole.name}}</option></select><span class="error" ng-show="submitted && role == \'0\'">Please select role</span></div></div></div></div><div class="row"><button type="submit" ng-click="subAdminFrm.$valid && saveSubAdminData()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="sub-admin" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="subAdminId" name="subAdminId"></div></form></div></div>');
$templateCache.put('app/pages/common/subAdmin/changePasswordModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Change Password</span></div><form class="form-horizontal" name="changePwdFrm" ng-submit="submitted = true" novalidate=""><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="newPassword" class="col-sm-4 text-right">New Password <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="newPassword" type="password" ng-model="newPassword" name="npassword" required="" class="form-control" placeholder="New Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]{8,}$/"> <span class="error" ng-show="submitted && changePwdFrm.npassword.$error.required">Please enter new password</span> <span class="error" ng-show="changePwdFrm.npassword.$error.pattern">Password should be 8 characters with number combination</span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="confirmPassword" class="col-sm-4 text-right">Confirm Password <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="confirmPassword" type="password" required="" ng-model="confirmPassword" name="cpassword" class="form-control" placeholder="Confirm Password" ng-pattern="newPassword"> <span class="error" ng-show="submitted && changePwdFrm.cpassword.$error.required">Please enter confirm password</span> <span class="error" ng-show="changePwdFrm.cpassword.$error.pattern">Confirm Password should match with password</span></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-click="changePwdFrm.$valid && changeUserPassword()">Yes</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">No</button></div></form></div>');
$templateCache.put('app/pages/common/subAdmin/deleteModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="deleteSubAdmin()">YES</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">NO</button></div></div>');
$templateCache.put('app/pages/common/subAdmin/statusModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="changeStatus()">Yes</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">No</button></div></div>');
$templateCache.put('app/pages/common/subAdmin/subAdmin.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-9"><div class="col-md-3"><input id="name" name="name" class="form-control filter-fullname" placeholder="Full Name" type="text" ng-model="vm.name"></div><div class="col-md-3"><input id="email" name="email" class="form-control filter-fullname" placeholder="Email" type="text" ng-model="vm.email"></div><div class="col-md-3"><select id="status" class="form-control" ng-model="vm.status" name="status"><option value="">Select status</option><option value="Active">Active</option><option value="Inactive">Inactive</option></select></div><div class="col-md-3" ng-init="getRoleList()"><select id="role" class="form-control" ng-model="vm.role" name="role"><option value="">Select Role</option><option ng-repeat="usrRole in roleList" value="{{usrRole.id}}">{{usrRole.name}}</option></select></div></div><div class="row"><div class="col-md-1 pull-right"><button type="button" ng-click="resetSearch()" class="pull-right btn btn-warning btn-with-icon ng-scope"><i class="ion-android-warning"></i>Reset</button></div><div class="col-md-1 pull-right"><button type="button" ng-click="searchApply()" class="pull-right btn btn-primary btn-with-icon ng-scope"><i class="ion-android-checkmark-circle"></i>Apply</button></div></div></div><div class="row"><div class="col-md-12" style="top: 15px"><button ng-if="checkPermission(\'SUB_ADMIN_CREATE\')" ng-click="addSubAdmin()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/common/user/addUser.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="gender = \'Other\'; status = \'Active\'"><div class="panel-content" ng-init="getEditedUser()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="userFrm" ng-submit="submitted = true" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="firstname" class="col-sm-3 text-right">First Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="firstname" type="text" placeholder="First Name" ng-model="firstname" limit-to="20" ng-maxlength="20" name="firstname" required="" class="form-control" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="submitted && userFrm.firstname.$error.required">Please enter first name</span> <span class="error" ng-show="userFrm.firstname.$error.pattern">Please enter valid first name</span> <span class="error" ng-show="userFrm.firstname.$error.maxlength && userFrm.firstname.$touched">First Name should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="lastname" class="col-sm-3 text-right">Last Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="lastname" type="text" placeholder="Last Name" ng-model="lastname" limit-to="20" ng-maxlength="20" name="lastname" required="" class="form-control" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="submitted && userFrm.lastname.$error.required">Please enter last name</span> <span class="error" ng-show="userFrm.lastname.$error.pattern">Please enter valid last name</span> <span class="error" ng-show="userFrm.lastname.$error.maxlength && userFrm.lastname.$touched">Last Name should not be greater than 20 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="email" class="col-sm-3 text-right">Email Address <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="email" type="email" placeholder="Email Address" ng-disabled="userId" ng-model="email" name="email" required="" class="form-control" ng-pattern="/^[a-z]+[a-zA-Z0-9._+]+@[a-zA-Z0-9]+\\.[a-z.]{2,5}$/"> <span class="error" ng-show="submitted && userFrm.email.$error.required">Please enter email</span> <span class="error" ng-show="userFrm.email.$error.pattern">Please enter valid email</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="mobile" class="col-sm-3 control-label">Phone number <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="mobile" limit-to="15" type="text" ng-model="mobile" name="mobile" placeholder="Phone Number" ng-minlength="10" required="" class="form-control" ng-pattern="/^\\+?\\d{2}[- ]?\\d{3}[- ]?\\d{5}$/"> <span class="error" ng-show="submitted && userFrm.mobile.$error.required">Please enter phone number</span> <span class="error" ng-show="userFrm.mobile.$error.pattern">Please enter valid phone number</span> <span class="error" ng-show="userFrm.mobile.$error.minlength">Number must contain atleast 10 digits</span></div></div></div></div><div class="row" ng-if="!userId?true:false"><div class="col-md-6"><div class="form-group row clearfix"><label for="password" class="col-sm-3 control-label">Password <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="password" type="password" ng-model="user.password" name="password" required="" class="form-control" placeholder="Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]{8,}$/"> <span class="error" ng-show="submitted && userFrm.password.$error.required">Please enter password</span> <span class="error" ng-show="userFrm.password.$error.pattern">Password should be min 8 characters with number combination</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label" style="padding: 0px">Confirm Password <span class="asterisk_input"></span></label><div class="col-sm-9"><input type="password" required="" ng-model="user.newPassword" name="newPassword" class="form-control" id="newPassword" placeholder="Confirm Password" ng-pattern="user.password"> <span class="error" ng-show="submitted && userFrm.newPassword.$error.required">Please enter confirm password</span> <span class="error" ng-show="userFrm.newPassword.$error.pattern">Confirm Password should match with password</span></div></div></div></div><div class="row"><button type="submit" ng-click="userFrm.$valid && saveUserData()" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="user" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="userId" name="userId"></div></form></div></div>');
$templateCache.put('app/pages/common/user/changePasswordModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Change Password</span></div><form class="form-horizontal" name="changePwdFrm" ng-submit="submitted = true" novalidate=""><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="newPassword" class="col-sm-4 text-right">New Password <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="newPassword" type="password" ng-model="newPassword" name="npassword" required="" class="form-control" placeholder="New Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]{8,}$/"> <span class="error" ng-show="submitted && changePwdFrm.npassword.$error.required">Please enter new password</span> <span class="error" ng-show="changePwdFrm.npassword.$error.pattern">Password should be 8 characters with number combination</span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="confirmPassword" class="col-sm-4 text-right">Confirm Password <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="confirmPassword" type="password" required="" ng-model="confirmPassword" name="cpassword" class="form-control" placeholder="Confirm Password" ng-pattern="newPassword"> <span class="error" ng-show="submitted && changePwdFrm.cpassword.$error.required">Please enter confirm password</span> <span class="error" ng-show="changePwdFrm.cpassword.$error.pattern">Confirm Password should match with password</span></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-click="changePwdFrm.$valid && changeUserPassword()">Yes</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">No</button></div></form></div>');
$templateCache.put('app/pages/common/user/deleteModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="deleteUser()">YES</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">NO</button></div></div>');
$templateCache.put('app/pages/common/user/statusModal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="changeStatus()">Yes</button> <button type="button" class="btn btn-warning" ng-click="closeModal()">No</button></div></div>');
$templateCache.put('app/pages/common/user/user.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-9"><div class="col-md-3"><input id="name" name="name" class="form-control filter-fullname" placeholder="Full Name" type="text" ng-model="vm.name"></div><div class="col-md-3"><input id="email" name="email" class="form-control filter-fullname" placeholder="Email" type="text" ng-model="vm.email"></div><div class="col-md-3"><select id="status" class="form-control" ng-model="vm.status" name="status"><option value="">Select status</option><option value="Active">Active</option><option value="Inactive">Inactive</option></select></div><div class="col-md-3"><input id="phone_number" name="phone_number" class="form-control filter-fullname" placeholder="Phone Number" type="text" ng-model="vm.phone_number"></div></div><div class="row"><div class="col-md-1 pull-right"><button type="button" ng-click="resetSearch()" class="pull-right btn btn-warning btn-with-icon ng-scope"><i class="ion-android-warning"></i>Reset</button></div><div class="col-md-1 pull-right"><button type="button" ng-click="searchApply()" class="pull-right btn btn-primary btn-with-icon ng-scope"><i class="ion-android-checkmark-circle"></i>Apply</button></div></div></div><div class="row"><div class="col-md-12" style="top: 20px"><button ng-click="addUser()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/common/user/verification.html','<main class="auth-main"><div class="auth-block" ng-init="verifyUser()"><h1>Verification</h1><div class="form-group"><div class="col-sm-12 col-xs-12 pull-right"><div class="form-group"><div class="alert alert-success" ng-show="success_message"><span class="text-info">{{ success_message }}</span></div><div class="alert alert-danger" ng-show="error_message"><span class="text-success">{{ error_message }}</span></div></div></div></div></div></main>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-if="checkPermission(item.permissionKey) || item.name == \'dashboard\'" ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="{ selected: currentState==item.name}" ba-sidebar-toggling-item="item" title="{{::item.menuName}}"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>Hearing</span>Tool</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{::( \'defaultImg\' | profilePicture )}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/profile"><i class="fa fa-user"></i>Profile</a></li><li><a href="" class="signout" ng-click="logOut()"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/common/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div><div class="row"><div ba-panel="" ba-panel-title="Users" ba-panel-class="xmedium-panel with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div>');}]);